/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Normalización de tickets y entrega definitiva de apartados
*      3       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Mantenimiento de cuentas de apartados
*      4       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Entrega definitiva no se detiene por impresión de abono
*      5       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Registro de abonos no se detiene por impresión
*      6       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Termino de apartado no se detiene por impresión de acuse
*      7       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Modo entrega definitiva estable durante cobro final
*      8       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Trazas de depuración para término de apartados
*      9       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Trazas de depuración para entrega definitiva
*      10      | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Actualización local de status ENTREGADO en entrega definitiva
*      11      | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Normalización segura de mensajes de error
*      12      | 05/06/2026 | Lic. José Luis Aragón Cervantes  | Recuperación de preventas entre cajas
*      13      | 08/06/2026 | Lic. José Luis Aragón Cervantes  | Mayor visibilidad en datos clave de tickets de venta y apartados
*      14      | 26/08/2026 | Lic. José Luis Aragón Cervantes  | Concepto y grupo visibles en cabecero de ticket de apartados
*      15      | 27/08/2026 | Lic. José Luis Aragón Cervantes  | Caja obligatoria normalizada para resumen de cortes
*      16       | 23/09/2026 | LIC. José Luis Aragón C.                       | Ortografía: caracteres reparados a UTF-8
* ---------------------------------------------------------------------------------------
*/

import { createContext, useContext, useEffect, useState, useRef } from "react";
import { useRequest } from "../System/RequestContext";
import { useConfiguracion } from "../System/ConfiguracionContext";
import { useArticulos } from "../../context/Catalogos/ArticulosContext";
import { getDateStringV3, getDateString, getDateStringV2, NumberFormat$ } from "../../settings/utils"
import { buildTicketVentaParts, layoutTieneObjetos, resolveTicketLayout } from "../../settings/ticketVentaEscape";
import { imprimirTicketEnPrinterTools } from "../../settings/ticketImpresion";
import { buildTicketApartadoClasicoParts, buildTicketVentaClasicoParts } from "../../settings/ticketVentaClasico";
import { buildTicketApartadoPersonalizadoParts } from "../../settings/ticketApartadoPersonalizado";
import { buildTicketAbonoApartadoParts } from "../../settings/ticketAbonoApartadoEscape";
import { buildTicketAcuseEntregaPersonalizadoParts } from "../../settings/ticketAcuseEntregaPersonalizado";

import {
    apiParametrosCaja,
    apiVentasList,
    apiVentasFolio,
    apiIncrementaVentasFolio,
    apiRegistrarArticuloPorEscaneo,
    apiRegistrarArticuloVenta,
    apiRegistrarEscaneosFromList,
    apiBuscarClientePorNombre,
    apiBuscarClientePorClave,
    apiEliminarPartida,
    apiEliminarVenta,
    apiSumarPartidaVenta,
    apiRestarPartidaVenta,
    apiTerminarVenta,
    apiTerminarCotizacion,
    apiMontoEnLetra,
    apiAplicaDescuentoAClienteVenta,
    apiRecalcularCostosClienteVenta,
    apiObtenerRemisionVenta,
    apiFirmarPreventa,
    apiTransferirPreventaCaja,
    apiInyectarPreventaAVenta,
    apiInyectarCotizacionAVenta,
    apiRegistrarApartadoList,
    apiRegistrarAbonoApartado,
    apiBuscarEstadoCuenteClienteApartados,
    apiCambiarCostoArticuloApartado,
    apiListaAlmacenesExhibidores,
    apiCancelarApartado,
    apiEntregaDefinitivaApartado,
    apiTerminarApartado,
    apiMantenimientoCuentasApartados,
    apiAplicarDescuentosVentas,
    apiCorteCaja,
    apiVentasDia,
    apiListaCajasRegistro,
    apiEliminarVentaYApartados,
    apiVentasPeriodoAlmacen,
    apiStatusCaja,
    apiEliminarVentaFull,
    apiLimpiarPreventas,
    apiLimpiarPreventasPortatil,
    apiCreditoClientesMigrarVenta,
    apiResumenTotalesCaja,
} from "../../settings/ApiConfig";

import { isErrorForm, isNullOrEmpty, handleValidarStrings, handleValidarTelefono, handleValidarCorreo, handleValidarNumerico, handleValidarHoras, getDateTimePost, getDatePost, getTimePost } from "../../settings/utils";
import { defaultTypes } from "../../settings/enums";
import { useLayout } from "../System/LayoutContext";
import { useNavigate } from "react-router-dom";
import { useSesion } from "../../context/System/SesionContext";

import { HelpOutlineRounded, TrendingUpRounded } from "@mui/icons-material";
import { getResponseModel } from "../../settings/responseModel";
import { getPickersYearUtilityClass } from "@mui/x-date-pickers/YearCalendar/pickersYearClasses";

import { format } from "date-fns";
import { defaultGetRowsToExport } from "@mui/x-data-grid/internals";

const getErrorMessage = (error) => {
    if (!error) return "";
    if (typeof error === "string") return error;
    if (error.message) return error.message;
    if (error.Message) return error.Message;
    if (error.response?.message) return error.response.message;
    if (error.response?.Message) return error.response.Message;
    if (error.result?.message) return error.result.message;
    if (error.result?.Message) return error.result.Message;
    try {
        return JSON.stringify(error);
    } catch {
        return String(error);
    }
};

const encodeTicketDatoClave = (textEncoder, texto) => (
    textEncoder.encode('\x1B\x45\x01\x1B\x21\x10' + texto + '\x1B\x21\x00\x1B\x45\x00')
);

const COMANDO_APERTURA_CAJON = new Uint8Array([0x1B, 0x70, 0x00, 0x32, 0x32]);

const getVentaTotalesForm = () => ({
    subTotal: 0,
    totalDescuento: 0,
    totalIVA: 0,
    total: 0,
    tipoPago: "EFECTIVO",
    montoTipoPago: 0,
    montoEfectivo: 0,
    totalCambioDevueltoACliente: 0,
    montoEnLetra: "",
    serialTarjetaChequeVale: "",
    idCliente: ""
});

const getArticuloActualForm = () => ({
    ispartida: { value: "" },
    fecharegistro: { value: "" },
    pc: { value: "" },
    remision: { value: 0 },
    clavecliente: { value: "" },
    razonsocial: { value: "" },
    clavearticulo: { value: "" },
    descriciopn: { value: "" },
    descriciopncorta: { value: "" },
    medida: { value: 0 },
    tipomaterial: { value: "" },
    cantidad: { value: 0 },
    costocliente: { value: 0 },
    descuento: { value: 0 },
    iva: { value: 0 },
    subtotal: { value: 0 },
    total: { value: 0 },
    costounitario: { value: 0 },
    costocompra: { value: 0 },
    statusmonitoreo: { value: true },
    statusimpresion: { value: false },
    vendedorpreventa: { value: "" },
    foliopreventa: { value: 0 },
    almacenexhibidor: { value: "" },
    usuario: { value: "" },
    porcentajedescuento: { value: 0 },
});

//Este es el formato de recepción de  la tabla de Remision_Temporal
// const getVentasList = () => [
//     { ispartida: "" },
//     { fecharegistro: "" },
//     { pc: "" },
//     { remision: 0 },
//     { clavecliente: "" },
//     { razonsocial: "" },
//     { clavearticulo: "" },
//     { descriciopn: "" },
//     { descriciopncorta: "" },
//     { medida: 0 },
//     { tipomaterial: "" },
//     { cantidad: 0 },
//     { costocliente: 0 },
//     { descuento: 0 },
//     { iva: 0 },
//     { subtotal: 0 },
//     { total: 0 },
//     { costounitario: 0 },
//     { costocompra: 0 },
//     { statusmonitoreo: true },
//     { statusimpresion: false },
//     { vendedorpreventa: "" },
//     { foliopreventa: 0 },
//     { almacenexhibidor: "" },
//     { usuario: "" },
//     { porcentajedescuento: 0 },
// ];

const normalizeEndDate = (date) => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
};

const normalizeStartDate = (date) => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
};

export const VentasContext = createContext();
export const VentasProvider = (props) => {
    const { pcData, usuarioData, handleObtenerParametrosCaja, parametrosCajaForm, setParametrosCajaForm, tipoUsuario, usuarioEnSesion } = useSesion();
    const { GetRequest, PostRequest } = useRequest()
    const { handleOpenAlert, handleOpenLoader } = useLayout();
    const { handleSendBeepback } = useConfiguracion();

    const navigation = useNavigate();
    const { handleObtenerArticuloByClave, handleBuscarArticuloFullData } = useArticulos();

    const [partidaSeleccionada, setPartidaSeleccionada] = useState([]);
    const [partidaSeleccionadaPreventas, setpartidaSeleccionadaPreventas] = useState([]);

    const [openModal, setOpenModal] = useState(false); // Modal de menu desplegable
    const [openModalPreventa, setOpenModalPreventa] = useState(false); // Modal de menu desplegable
    const [openModalPartidas, setOpenModalPartidas] = useState(false);
    const [openModalImpresion, setOpenModalImpresion] = useState(false);
    const [openModalFirma, setOpenModalFirma] = useState(false);
    const [openModalJalarPreventaCotizacion, setOpenModalJalarPreventaCotizacion] = useState(false);
    //const [openCobrarApartado, setOpenCobrarApartado]=useState(false);
    const [openModalCobrarVenta, setOpenModalCobrarVenta] = useState(false);
    const [openModalCobrarAbonoApartado, setOpenModalCobrarAbonoApartado] = useState(false);
    const [isModoEntregaDefinitiva, setIsModoEntregaDefinitiva] = useState(false);
    const [abonoDataGenerado, setAbonoDataGenerado] = useState(null);
    const [openModalCambioCostoApartado, setOpenModalCambioCostoApartado] = useState(false);
    const [openModalCancelarApartado, setOpenModalCancelarApartado] = useState(false);

    const [openModalRecuperarPreventa, setOpenModalRecuperarPreventa] = useState(false);
    const [openModalRecuperarPreventaFirma, setOpenModalRecuperarPreventaFirma] = useState(false);
    const [openModalGenerarApartado, setOpenModalGenerarApartado] = useState(false);
    const [openModalValidatorDescuentos, setOpenModalValidatorDescuentos] = useState(false);
    const [mostrarBuscadorArticulos, setMostrarBuscadorArticulos] = useState(false);

    //Reporte de ventas y reposiciones
    const [fechaInicioVentas, setFechaInicioVentas] = useState(normalizeStartDate(new Date()));
    const [fechaFinVentas, setFechaFinVentas] = useState(normalizeEndDate(new Date()));
    const [almacenSeleccionadoVentas, setAlmacenSeleccionadVentas] = useState(null);
    const [filtroArticuloVentas, setFiltroArticuloVentas] = useState("");
    const [listaVentasAgrupadas, setListaVentasAgrupadas] = useState([]);

    const [moduloActivo, setModuloActivo] = useState(""); //Para switcheo entre preventas y venta súper

    //Datos de venta en curso actual
    const [ventaTotales, setVentaTotales] = useState(getVentaTotalesForm());
    const [idPartida, setIdPartida] = useState(0);

    const [articuloActual, setArticuloActual] = useState(getArticuloActualForm());
    const [clienteForm, setClienteForm] = useState({});
    const [listaRemisionTemporal, setListaRemisionTemporal] = useState([]);
    const [listaPreventaTemporal, setListaPreventaTemporal] = useState([]);
    const [listaAlmacenesExhibidores, setListaAlmacenesExhibidores] = useState([]);
    const [listaCajas, setListaCajas] = useState([]);
    const [listaCortes, setListaCortes] = useState([]);
    const [listaVentas, setListaVentas] = useState([]);


    //UsoExclusivo de descuentos-----------------------
    const [listaVenta, setListaVenta] = useState([]);
    //-------------------------------------------------

    const [corteSeleccionado, setCorteSeleccionado] = useState([]);

    const [nombreTicket, setNombreTicket] = useState("");
    const [dataTicket, setDataTicket] = useState([]);

    const [dataRemision, setDataRemision] = useState([]);
    const [dataPreVenta, setDataPreVenta] = useState([]);

    const [openModalFirmarVenta, setOpenModalFirmarVenta] = useState(false);
    const [openModalBuscarCliente, setOpenModalBuscarCliente] = useState(false);
    const [openModalBuscarArticulos, setOpenModalBuscarArticulos] = useState(false);
    const [openModalBuscarArticulosPreventas, setOpenModalBuscarArticulosPreventas] = useState(false);

    const [statusKeyActions, setStatusKeyActions] = useState(false);
    const [statusImpresionDirecta, setStatusImpresionDirecta] = useState(false);
    const [statusCloseModal, setStatusCloseModal] = useState(true);
    const [statusActualApartado, setStatusActualApartado] = useState(false);
    const [dataEstadoCuentaApartado, setDataEstadoCuentaApartado] = useState({
        nombrecliente: "",
        apartados: [],
        abonos: [],
        totalabonado: 0,
    });
    const [rowPartidaApartadoFind, setRowPartidaApartadoFind] = useState({});
    const [abonoApartadoSeleccionado, setAbonoApartadoSeleccionado] = useState({});
    const [statusAbrirDescuentos, setStatusAbrirDescuentos] = useState(false);
    const [statusValidarCliente, setStatusValidarCliente] = useState(false);
    const [statusWaiting, setStatusWaiting] = useState(false);

    const [tipoVenta, setTipoVenta] = useState("VENTA");
    const [dataApartados, setDataApartados] = useState([]);

    const [barcodeAnterior, setBarcodeAnterior] = useState("");

    const [ventaMontosForm, setVentaMontosForm] = useState({
        remision: 0,
        pc: "",
        tipopago: 0,
        montodecuento: 0,
        montosubtotal: 0,
        montoiva: 0,
        montototal: 0,
        montotipopago: 0,
        montoefectivo: 0,
        montocambio: 0
    });


    const [statusCobroApartado, setStatusCobroApartado] = useState(false);

    const handleAbrirMenuModal = () => {
        setStatusKeyActions(true);
        setOpenModal(true);
    };

    const handleCerrarMenuModal = () => {
        setStatusKeyActions(false);
        setOpenModal(false);
    };

    const handleAbrirMenuModalPreventa = () => {
        setOpenModalPreventa(true);
    };

    const handleCerrarMenuModalPreventa = () => {
        setOpenModalPreventa(false);
        setStatusKeyActions(false);
    };

    const handleRefreshDataHost = (caja) => {
        setParametrosCajaForm({
            ...parametrosCajaForm,
            Caja: { value: caja, error: false, TypeError: "" }
        });
    };

    const handleClickRegresarMainDashboard = () => {
        const route = "/*";
        navigation(route);
    };

    const handleChangePartidaSeleccionada = (partida) => {
        setPartidaSeleccionada(partida);
    };

    const handleChangePartidaSeleccionadaPreventas = async (partida) => {
        setpartidaSeleccionadaPreventas(partida);
        const dataX = await handleBuscarArticuloFullData(partida.clavearticulo.trim(), partida.medida);
        setBarcodeAnterior(dataX.codigobarras.trim());
    };

    const handlDobleClickEditarPartida = async (row) => {
        let idPartida = row.idpartida;

        if (!idPartida) {
            return;
        }
        setPartidaSeleccionada(row);
        setOpenModalPartidas(true);
    };

    const handleInicializarVentanaVentas = async () => {
        await handleObtenerParametrosCaja();
        setListaRemisionTemporal([]);
        setVentaTotales(getVentaTotalesForm());
        setClienteForm({});
        setPartidaSeleccionada([]);
        setStatusKeyActions(false);
        setListaVenta([]);
        setStatusCobroApartado(false);
    };

    const handleInicializarVentanaPreVentas = async () => {
        await handleObtenerParametrosCaja();
        setListaPreventaTemporal([]);
        setVentaTotales(getVentaTotalesForm());
        setClienteForm({});
    };

    const handleClickRefrescarDatosVenta = async () => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        if (parametrosCajaForm.folioventa === undefined)
            return;

        const data = await handleObtenerVentas(parametrosCajaForm.tipoventa === "VENTA" ? parametrosCajaForm.tipoventa : "VENTA", parametrosCajaForm.folioventa, parametrosCajaForm.caja);
        await handleRetotalizarCuentaVenta(data ?? []);
        setStatusKeyActions(false);
    };

    const handleClickRefrescarDatosPreVenta = async () => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        if (parametrosCajaForm.foliopreventa === undefined)
            return;

        const data = await handleObtenerVentas("PREVENTA", parametrosCajaForm.foliopreventa, parametrosCajaForm.caja);
        await handleRetotalizarCuentaVenta(data ?? []);
    };

    const handleObtenerVentas = async (TipoVenta, FolioRemision, Caja) => {
        if (Caja === "CAJA-DEFAULT") {
            return;
        }

        if (TipoVenta === undefined || TipoVenta === null || FolioRemision === null || FolioRemision === undefined || Caja === null || Caja === undefined) {
            return;
        }

        const consultaVentas = {
            folioventa: FolioRemision,
            caja: Caja,
            tipoventa: TipoVenta,
        };

        setStatusWaiting(true);
        const response = await PostRequest({
            url: apiVentasList,
            body: consultaVentas,
            // loader: "Consultando lista ventas por caja...",
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        if (response.result === null) {
            return;
        }

        const data = response.result.listaremisiontemporal;
        if (TipoVenta === "VENTA") {
            setListaRemisionTemporal(data);
        }
        else if (TipoVenta === "PREVENTA") {
            setListaPreventaTemporal(data);
        }
        return data;
    };

    const obtenerListaVentas = async () => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            await handleObtenerParametrosCaja();
            return;
        }

        let TipoVenta = "VENTA";
        let FolioRemision = parametrosCajaForm.folioventa;
        let Caja = parametrosCajaForm.caja;

        // Verificación de condiciones nulas o indefinidas
        if (TipoVenta === null || FolioRemision === null || FolioRemision === undefined || Caja === undefined) {
            return [];
        }

        // Crear el objeto de consulta
        const consultaVentas = {
            folioventa: FolioRemision,
            caja: Caja,
            tipoventa: TipoVenta,
        };

        // Realizar la petición
        setStatusWaiting(true);
        const response = await PostRequest({
            url: apiVentasList,
            body: consultaVentas,
        });
        setStatusWaiting(false);

        // Manejo de errores en la respuesta
        if (response.hasError) {
            handleOpenAlert(response.message);
            return [];
        }

        // Si el resultado es nulo, devolver un array vacío
        if (response.result === null) {
            return [];
        }

        // Extraer y devolver los datos
        const data = response.result.listaremisiontemporal;
        return data || []; // Si `data` es nulo o indefinido, se devuelve un array vacío        
    };

    const handleObtenerFolioCajaVentas = async (data) => {
        let id = data;

        setStatusWaiting(true);
        const response = await GetRequest({
            url: apiVentasFolio.replace("{idCaja}", id),
            // loader: "Consultando folio ventas por caja...",
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            setParametrosCajaForm({
                ...parametrosCajaForm,
                FolioVenta: { value: 0, error: response.hasError, TypeError: response.Message },
            })
            return;
        }
        else {
            if (response.result != null) {
                setParametrosCajaForm({
                    ...parametrosCajaForm,
                    FolioVenta: { value: response.result, error: false, TypeError: "" }
                })
                return;
            }
            else {
                setParametrosCajaForm({
                    ...parametrosCajaForm,
                    FolioVenta: { value: 0, error: false, TypeError: "" }
                })
            }
        }
    };

    const handleIncrementarFolioCajaVentas = async (data) => {
        let caja = data;

        const response = await GetRequest({
            url: apiIncrementaVentasFolio.replace("{caja}", caja),
            loader: "Incrementando folio ventas por caja...",
        });


        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }
    };

    const handleRegistrarArticuloSubmitVenta = async (codigobarras, almacenExhibidor) => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            await handleObtenerParametrosCaja();
            return;
        }

        setBarcodeAnterior(codigobarras);

        if (codigobarras == null || codigobarras === undefined) {
            handleSendBeepback("ERROR");
            return;
        }

        //es necesario mandar el dominio AlmacenExhiobidor y Remisión en el JSON para registrar el articulo en venta
        const datosArticuloEscaneo = {
            pc: parametrosCajaForm.caja,
            remision: parametrosCajaForm.folioventa,
            tiporegistro: "VENTA",
            dominio: almacenExhibidor.trim().length > 0 ? almacenExhibidor.trim() : parametrosCajaForm.dominio.trim(),
            codigobarras: codigobarras,
            usuario: usuarioData.Usuario,
            clavecliente: clienteForm.clavecliente
        };

        // setStatusWaiting(true);
        const response = await PostRequest({
            url: apiRegistrarArticuloVenta,
            body: datosArticuloEscaneo,
            loader: "Procedimiento de registro de artículo en venta...",
        });
        //setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }
        else {
            if (response.result === null) {
                handleOpenAlert(response.message);
                return;
            }
        }

        handleClickRefrescarDatosVenta();
        setStatusKeyActions(false);
    };

    const handleRegistrarArticuloSubmitPreVenta = async (codigobarras, almacenExhibidor) => {
        if (codigobarras == null || codigobarras === undefined) {
            handleSendBeepback("ERROR");
            return false;
        }

        setBarcodeAnterior(codigobarras);
        let AlmacenExhibidorEnter = almacenExhibidor;

        //es necesario mandar el dominio AlmacenExhiobidor y Remisión en el JSON para registrar el articulo en venta
        const datosArticuloEscaneo = {
            pc: parametrosCajaForm.caja,
            remision: parametrosCajaForm.foliopreventa,
            tiporegistro: "PREVENTA",
            dominio: AlmacenExhibidorEnter ? AlmacenExhibidorEnter : parametrosCajaForm.dominio,
            codigobarras: codigobarras,
            usuario: usuarioData.Usuario,
            clavecliente: clienteForm.clavecliente
        };

        // setStatusWaiting(true);
        const response = await PostRequest({
            url: apiRegistrarArticuloPorEscaneo,
            body: datosArticuloEscaneo,
            loader: "Procedimiento de registro de artículo en preventa...",
        });
        // setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return false;
        }
        else {
            if (response.result === null) {
                handleOpenAlert(response.message);
                return false;
            }
        }

        handleClickRefrescarDatosPreVenta();
        return true;
    };

    const handleCargarEscaneosFromFile = async (e) => {
        const archivo = e.target.files[0]; // Obtiene el archivo seleccionado

        if (!archivo) {
            handleOpenAlert("No se seleccionó ningún archivo de texto.");
            return;
        }

        //Se usa FileReader para leer el contenido del archivo en caso de tener datos
        // const listaCodigos = await new Promise((resolve, reject) => {
        //     const lector = new FileReader();
        //     lector.onload = (evento) => {
        //         const contenido = evento.target.result;
        //         const lineas = contenido.split('\n');
        //         const codigosProcesados = lineas
        //             .map(linea => linea.trim())
        //             .filter(linea => linea !== "")
        //             .map((codigo) => ({codigo}));
        //         resolve(codigosProcesados);
        //     };
        //     lector.onerror = (error) => reject(error);
        //     lector.readAsText(archivo);
        // });
        const listaCodigos = await new Promise((resolve, reject) => {
            const lector = new FileReader();
            lector.onload = (evento) => {
                const contenido = evento.target.result;
                const lineas = contenido.split('\n');
                const codigosProcesados = lineas
                    .map(linea => linea.trim())
                    .filter(linea => linea !== ""); // Solo los códigos, sin propiedades
                resolve(codigosProcesados);
            };
            lector.onerror = (error) => reject(error);
            lector.readAsText(archivo);
        });

        const dataSaveList = {
            pc: parametrosCajaForm.caja,
            remision: parametrosCajaForm.tipoventa === "VENTA" ? parametrosCajaForm.folioventa : parametrosCajaForm.foliopreventa,
            tiporegistro: parametrosCajaForm.tipoventa,
            dominio: parametrosCajaForm.dominio,
            codigobarras: listaCodigos,
            usuario: usuarioData.Usuario,
            clavecliente: clienteForm.clavecliente
        };

        //setStatusWaiting(true);
        const response = await PostRequest({
            url: apiRegistrarEscaneosFromList,
            body: dataSaveList,
            loader: "Cargando venta por códigos desde archivo...",
        });
        //setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        const data = await handleObtenerVentas(parametrosCajaForm.tipoventa, parametrosCajaForm.tipoventa === "VENTA" ? parametrosCajaForm.folioventa : parametrosCajaForm.foliopreventa, parametrosCajaForm.caja);
        await handleRetotalizarCuentaVenta(data ?? []);
        e.target.value = null;
    };

    const handleBuscarClienteFromName = async (name) => {
        if (name.length === 0)
            return
        if (handleValidarStrings(name).length > 0)
            return;

        setStatusWaiting(true);
        const response = await GetRequest({
            url: apiBuscarClientePorNombre.replace("{nombre}", name),
            loader: "Cargando datos de cliente...",
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }
        else {
            if (response.result === null) {
                handleOpenAlert(response.message);
                return;
            }
        }

        setClienteForm(response?.result)

        if (tipoUsuario == "SA" || tipoUsuario == "ADMINISTRADOR") {
            setStatusAbrirDescuentos(true);
        }
        else {
            if (clienteForm.porcentajedescuento > 0)
                if (ventaTotales.totalDescuento === 0)
                    handleAplicarDescuentoAClienteVenta(clienteForm);
        }

        return;
    };

    const handleRecalcularCostosClienteVenta = async (cliente) => {
        const hayPartidasPreventa = Array.isArray(listaPreventaTemporal) && listaPreventaTemporal.length > 0;
        const hayPartidasVenta = Array.isArray(listaRemisionTemporal) && listaRemisionTemporal.length > 0;
        const tipoRegistro = parametrosCajaForm.tipoventa === "PREVENTA" || (hayPartidasPreventa && !hayPartidasVenta)
            ? "PREVENTA"
            : "VENTA";
        const remision = tipoRegistro === "PREVENTA" ? parametrosCajaForm.foliopreventa : parametrosCajaForm.folioventa;
        const partidas = tipoRegistro === "PREVENTA" ? listaPreventaTemporal : listaRemisionTemporal;

        if (!Array.isArray(partidas) || partidas.length === 0) {
            return;
        }

        if (!cliente?.clavecliente || !remision || parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        const payload = {
            pc: parametrosCajaForm.caja,
            remision: remision,
            tiporegistro: tipoRegistro,
            dominio: parametrosCajaForm.dominio,
            codigobarras: "",
            usuario: usuarioData.Usuario,
            clavecliente: cliente.clavecliente,
        };

        setStatusWaiting(true);
        const response = await PostRequest({
            url: apiRecalcularCostosClienteVenta,
            body: payload,
            loader: "Recalculando costos por cliente...",
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        if (tipoRegistro === "PREVENTA") {
            await handleClickRefrescarDatosPreVenta();
        }
        else {
            await handleClickRefrescarDatosVenta();
        }
    };
    const handleBuscarClienteFromClave = async (clave) => {
        if (clave.length === 0) {
            return
        }

        if (handleValidarStrings(clave).length > 0) {
            return;
        }

        setStatusWaiting(true);
        const response = await GetRequest({
            url: apiBuscarClientePorClave.replace("{clave}", clave),
            loader: "Cargando datos de cliente...",
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            setStatusKeyActions(false);
            return;
        }

        if (response.result === null) {
            handleOpenAlert(response.message);
            setStatusKeyActions(false);
            return;
        }

        setClienteForm(response?.result);
        await handleRecalcularCostosClienteVenta(response?.result);

        return;
    };

    //Status para ventana modal de descuentos a clientes
    const [statusDescuentosModalView, setStatusDescuentosModalView] = useState(false);
    const handleViewFormDescuentos = (status, cliente = null) => {
        if (cliente) setClienteForm(cliente);
        setStatusAbrirDescuentos(status)
    };

    //Status para ventana modal de validar cliente
    const handleAbrirValidarCliente = () => {
        setStatusKeyActions(true);
        setStatusValidarCliente(true);
    };

    const handleCerrarValidarCliente = () => {
        setStatusKeyActions(false);
        setStatusValidarCliente(false);
    };

    const handleRetotalizarCuentaVenta = async (ventasList) => {
        if (ventasList.length === 0) {
            setVentaTotales({
                ...ventaTotales,
                totalDescuento: 0,
                subTotal: 0,
                totalIVA: 0,
                total: 0,
                montoEnLetra: "()",
            });
            return;
        }

        const totalDescuento = ventasList.reduce((acc, item) => acc + item.descuento, 0);
        const subTotal = ventasList.reduce((acc, item) => acc + item.subtotal, 0);
        const totalIVA = ventasList.reduce((acc, item) => acc + item.iva, 0);
        const total = ventasList.reduce((acc, item) => acc + item.total, 0);

        let montoletras = "";

        montoletras = await handleConsultaMontoLetra(total);

        setVentaTotales({
            ...ventaTotales,
            totalDescuento: totalDescuento,
            subTotal: subTotal,
            totalIVA: totalIVA,
            total: total,
            montoEnLetra: montoletras,
        });
        setStatusKeyActions(false);
    };

    const handleClickEliminarPartidaVentas = async (idpartida) => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }
debugger;
        if (idpartida === undefined)
            return;

        // Creamos una nueva variable para la URL reemplazada
        const apiUrl = apiEliminarPartida
            .replace("{remision}", parametrosCajaForm.tipoventa === "VENTA" ? parametrosCajaForm.folioventa : parametrosCajaForm.foliopreventa)
            .replace("{pc}", parametrosCajaForm.caja.trim())
            .replace("{idpartida}", idpartida)
            .replace("{tipoventa}", parametrosCajaForm.tipoventa === "VENTA" ? "VENTA" : "PREVENTA")
            .replace("{usuariopreventa}", usuarioData.Usuario || "");

        setStatusWaiting(true);
        const response = await GetRequest({
            url: apiUrl,
            loader: "Eliminando partida en venta actual...",
        });
        setStatusWaiting(false);
debugger;
        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        if (response.result === false) {
            handleOpenAlert("No se eiminó la partida de la venta");
            return;
        }

        await handleClickRefrescarDatosVenta();
    };

    const handleClickEliminarPartidaPreVentas = async (idpartida) => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        if (idpartida === undefined)
            return;

        // Creamos una nueva variable para la URL reemplazada
        const apiUrl = apiEliminarPartida
            .replace("{remision}", parametrosCajaForm.foliopreventa)
            .replace("{pc}", parametrosCajaForm.caja.trim())
            .replace("{idpartida}", idpartida)
            .replace("{tipoventa}", "PREVENTA")
            .replace("{usuariopreventa}", usuarioData.Usuario || "");

        setStatusWaiting(true);
        const response = await GetRequest({
            url: apiUrl,
            loader: "Eliminando partida en preventa actual...",
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        if (response.result === false) {
            handleOpenAlert("No se eiminó la partida de la preventa");
            return;
        }

        await handleClickRefrescarDatosPreVenta();
    };

    const handleClickEliminarVenta = async () => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        // Creamos una nueva variable para la URL reemplazada
        const apiUrl = apiEliminarVenta
            .replace("{remision}", parametrosCajaForm.folioventa)
            .replace("{pc}", parametrosCajaForm.caja.trim())
            .replace("{tipoventa}", "VENTA");

        const response = await GetRequest({
            url: apiUrl,
            loader: "Eliminando venta temporal actual...",
        });

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        if (response.result === false) {
            handleOpenAlert("No se eiminó la venta");
            return;
        }

        await handleInicializarVentanaVentas();
        setStatusKeyActions(false);
    };

    const handleClickEliminarVentaFull = async () => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        if (listaRemisionTemporal.length === 0) {
            handleOpenAlert("No hay artículos en la venta para eliminar");
            return;
        }

        const data = {
            partidas: listaRemisionTemporal.map(p => ({
                remision: p.remision,
                pc: p.pc,
                foliopreventa: p.foliopreventa,
                vendedorpreventa: p.vendedorpreventa,
                clavearticulo: p.clavearticulo,
                medida: p.medida,
                cantidad: p.cantidad,
                descripcion: p.descripcion
            }))
        };

        const response = await PostRequest({
            url: apiEliminarVentaFull,
            body: data,
            loader: "Eliminando venta completa con preventas...",
        });

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        if (response.result === false) {
            handleOpenAlert("No se eliminó la venta");
            return;
        }

        await handleInicializarVentanaVentas();
        setStatusKeyActions(false);
    };

    const handleClickEliminarPreVenta = async () => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        // Creamos una nueva variable para la URL reemplazada
        const apiUrl = apiEliminarVenta
            .replace("{remision}", parametrosCajaForm.foliopreventa)
            .replace("{pc}", parametrosCajaForm.caja.trim())
            .replace("{tipoventa}", "PREVENTA");

        setStatusWaiting(true);
        const response = await GetRequest({
            url: apiUrl,
            loader: "Eliminando preventa actual...",
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        await handleInicializarVentanaPreVentas();
    };

    const getCajaReporteValue = (caja) => {
        if (!caja) return "";
        const pc = caja.pc ?? caja.PC ?? caja.value ?? caja.label ?? caja;
        const text = String(pc ?? "").trim();
        return text && text !== "[object Object]" ? text.toUpperCase() : "";
    };

    const handleObtenerVentaDelDiaCajaFecha = async (caja, fechaventa, vendedor = "N-A") => {
        if (parametrosCajaForm?.caja === "CAJA-DEFAULT") return;

        if (vendedor === null || vendedor === undefined || vendedor === "") vendedor = "N-A";
        const pc = getCajaReporteValue(caja);
        if (!pc || !fechaventa) {
            return;
        }

        const fechaStr = getDateStringV3(fechaventa);

        setListaVentas([]);
        setListaCortes([]);

        const apiUrl = apiVentasDia
            .replace("{fechaventa}", fechaStr)
            .replace("{pc}", pc)
            .replace("{vendedor}", vendedor ?? "");

        setStatusWaiting(true);
        const response = await GetRequest({
            url: apiUrl,
            loader: "Obteniendo lista de ventas del día...",
        });
        setStatusWaiting(false);

        if (response?.hasError) {
            handleOpenAlert(response?.message ?? "Error al obtener ventas", "error");
            return;
        }
        //setDataChart([{ value: "", label: "" }]); datos de grafica en base a totales por tipo de pago

        setListaVentas(response?.result.ventas ?? []);
        setListaCortes(response?.result.cabecero ?? []);
    };


    const handleClickEliminarPreVentaDesdeVenta = async () => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        if (listaRemisionTemporal.length === 0) {
            handleOpenAlert("No hay artículos en la venta para eliminar");
            return;
        }

        handleCerrarMenuModal();

        await handleClickEliminarVentaFull();
    };

    const handleClickLimpiarPreventas = async () => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        handleCerrarMenuModal();

        const response = await PostRequest({
            url: apiLimpiarPreventas,
            loader: "Limpiando todas las preventas...",
        });

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        handleOpenAlert("Todas las preventas han sido eliminadas");
    };

    const handleClickEditarPartida = () => {
        setStatusKeyActions(true);
        setOpenModalPartidas(true);
        setStatusCloseModal(false);
    };

    const handleClickEditarPartidaPreventas = () => {
        setStatusKeyActions(true);
        setOpenModalPartidas(true);
        setStatusCloseModal(false);
    };

    const handleCerrarModalEditarPartidas = () => {
        setStatusKeyActions(false);
        setOpenModalPartidas(false);
        setStatusCloseModal(true);
    };

    const handleSumarPartidaVentas = async (cantidad, idpartida, clavearticulo, medida) => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        const datosArticuloEscaneo = {
            pc: parametrosCajaForm.caja,
            remision: parametrosCajaForm.folioventa,
            tiporegistro: parametrosCajaForm.tipoventa ? parametrosCajaForm.tipoventa : "VENTA",
            dominio: parametrosCajaForm.dominio,
            codigobarras: "",
            usuario: usuarioData.Usuario,
            clavecliente: clienteForm.clavecliente,
            idpartida: idpartida,
            cantidad: cantidad,
            clavearticulo: clavearticulo,
            medida: medida
        };

        //setStatusWaiting(true);
        const response = await PostRequest({
            url: apiSumarPartidaVenta,
            body: datosArticuloEscaneo,
            loader: "Sumando cantidad a partida...",
        });
        //setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        if (response.result === false) {
            handleOpenAlert("No se sumó la cantidad a la partida");
            return;
        }

        handleCerrarModalEditarPartidas();
        const data = await handleObtenerVentas("VENTA", parametrosCajaForm.folioventa, parametrosCajaForm.caja);
        await handleRetotalizarCuentaVenta(data ?? []);
    };

    const handleRestarPartidaVentas = async (cantidad, idpartida, clavearticulo, medida) => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        const datosArticuloEscaneo = {
            pc: parametrosCajaForm.caja,
            remision: parametrosCajaForm.folioventa,
            tiporegistro: parametrosCajaForm.tipoventa ? parametrosCajaForm.tipoventa : "VENTA",
            dominio: parametrosCajaForm.dominio,
            codigobarras: "",
            usuario: usuarioData.Usuario,
            clavecliente: clienteForm.clavecliente,
            idpartida: idpartida,
            cantidad: cantidad,
            clavearticulo: clavearticulo,
            medida: medida
        };

        //setStatusWaiting(true);
        const response = await PostRequest({
            url: apiRestarPartidaVenta,
            body: datosArticuloEscaneo,
            loader: "Restando cantidad a partida...",
        });
        //setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        if (response.result === false) {
            handleOpenAlert("No se restó la cantidad a la partida");
            return;
        }

        handleCerrarModalEditarPartidas();
        const data = await handleObtenerVentas("VENTA", parametrosCajaForm.folioventa, parametrosCajaForm.caja);
        await handleRetotalizarCuentaVenta(data ?? []);
    };

    const handleSumarPartidaPreVentas = async (cantidad, idpartida, clavearticulo, medida) => {
        if (idpartida === undefined) {
            return;
        }

        const datosArticuloEscaneo = {
            pc: parametrosCajaForm.caja,
            remision: parametrosCajaForm.foliopreventa,
            tiporegistro: parametrosCajaForm.tipoventa ? parametrosCajaForm.tipoventa : "PREVENTA",
            dominio: parametrosCajaForm.dominio,
            codigobarras: "",
            usuario: usuarioData.Usuario,
            clavecliente: clienteForm.clavecliente,
            idpartida: idpartida,
            cantidad: cantidad,
            clavearticulo: clavearticulo,
            medida: medida
        };

        //setStatusWaiting(true);
        const response = await PostRequest({
            url: apiSumarPartidaVenta,
            body: datosArticuloEscaneo,
            loader: "Sumando cantidad a partida preventa...",
        });
        //setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        if (response.result === false) {
            handleOpenAlert("No se sumó la cantidad a la partida preventa");
            return;
        }

        handleCerrarModalEditarPartidas();
        const data = await handleObtenerVentas("PREVENTA", parametrosCajaForm.foliopreventa, parametrosCajaForm.caja);
        await handleRetotalizarCuentaVenta(data ?? []);
    };

    const handleRestarPartidaPreVentas = async (cantidad, idpartida, clavearticulo, medida) => {
        if (idpartida === undefined) {
            return;
        }

        const datosArticuloEscaneo = {
            pc: parametrosCajaForm.caja,
            remision: parametrosCajaForm.foliopreventa,
            tiporegistro: parametrosCajaForm.tipoventa ? parametrosCajaForm.tipoventa : "PREVENTA",
            dominio: parametrosCajaForm.dominio,
            codigobarras: "",
            usuario: usuarioData.Usuario,
            clavecliente: clienteForm.clavecliente,
            idpartida: idpartida,
            cantidad: cantidad,
            clavearticulo: clavearticulo,
            medida: medida
        };

        //setStatusWaiting(true);
        const response = await PostRequest({
            url: apiRestarPartidaVenta,
            body: datosArticuloEscaneo,
            loader: "Restando cantidad a partida preventa...",
        });
        //setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        if (response.result === false) {
            handleOpenAlert("No se restó la cantidad a la partida preventa");
            return;
        }

        handleCerrarModalEditarPartidas();
        const data = await handleObtenerVentas("PREVENTA", parametrosCajaForm.foliopreventa, parametrosCajaForm.caja);
        await handleRetotalizarCuentaVenta(data ?? []);
    };

    const handleCerrarModalCobrarVenta = () => {
        setStatusKeyActions(false); //Falso ára que se enfoque lector de códigpo de barras
        setOpenModalCobrarVenta(false);
        setStatusCloseModal(true);
    };

    const terminoVentaRef = useRef(false);
    const cobrarAbonoRef = useRef(false);
    const entregaDefinitivaApartadoRef = useRef(false);

    const handleArirModalCobrarVenta = () => {
        if (listaRemisionTemporal.length === 0) {
            handleOpenAlert("No hay artículos en la venta para cobrar.");
            return;
        }

        terminoVentaRef.current = false;
        setStatusKeyActions(true);
        setOpenModalCobrarVenta(true);
        setStatusCloseModal(false);
    };

    const handleCerrarModalFirmarVenta = () => {
        setStatusKeyActions(false);
        setOpenModalFirarVenta(false);
        setStatusCloseModal(true);
    };

    const handleArirModalFirmarVenta = () => {
        setStatusKeyActions(true);
        setOpenModalFirmarVenta(true);
        setStatusCloseModal(false);
    };

    const handleCloseModalBuscarArticulos = () => {
        setStatusKeyActions(false);
        setOpenModalBuscarArticulos(false);
        setStatusCloseModal(true);
    };

    const handleArirModalBuscarArticulos = () => {
        setStatusKeyActions(true);
        setOpenModalBuscarArticulos(true);
        setStatusCloseModal(false);
    };

    const handleCloseModalBuscarArticulosPreventas = () => {
        setStatusKeyActions(false);
        setOpenModalBuscarArticulosPreventas(false);
        setStatusCloseModal(true);
    };

    const handleArirModalBuscarArticulosPreventas = () => {
        setStatusKeyActions(true);
        setOpenModalBuscarArticulosPreventas(true);
        setStatusCloseModal(false);
    };

    const handleCerrarModalBuscarCliente = () => {
        setStatusKeyActions(false);
        setOpenModalBuscarCliente(false);
        setStatusCloseModal(true);
    };

    const handleArirModalBuscarCliente = () => {
        setStatusKeyActions(true);
        setOpenModalBuscarCliente(true);
        setStatusCloseModal(false);
    };

    const handleConsultaMontoLetra = async (monto) => {
        // let MontoX = parseFloat(monto).toFixed(2);

        const response = await GetRequest({
            url: apiMontoEnLetra.replace("{monto}", monto),
        });

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        if (response.result.length === 0) {
            handleOpenAlert("No se realizó la operación de conversión de monto a letra");
            return;
        }

        return response.result;
    };

    const handClickCobrarVenta = async (data) => {
        if (terminoVentaRef.current) return;
        terminoVentaRef.current = true;

        try {
            if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
                return;
            }

            if (data == null || data === undefined) return;

            const folioActual = parametrosCajaForm.folioventa;

            const data2 = {
                ...data,
                tipoventa: "VENTA",
                foliocortecaja: parametrosCajaForm.foliocortecaja,
                remision: folioActual,
                pc: parametrosCajaForm.caja,
                usuario: usuarioData.Usuario,
                clavecliente: clienteForm.clavecliente,
                razonsocial: clienteForm.razonsocial,
                fechaventa: getDatePost(),
                horaventa: getTimePost(),
                factura: "",
                facturaelectronica: "",
                condicionesdepago: clienteForm.condicionespago,
                idnavegador: parametrosCajaForm.idcaja.trim(),
            };

            setStatusWaiting(true);
            const response = await PostRequest({
                url: apiTerminarVenta,
                body: data2,
                loader: "Realizando registro de venta en sistema"
            });
            setStatusWaiting(false);

            if (response.hasError) {
                handleOpenAlert(response.message);
                return;
            }

            if (response.result === false) {
                handleOpenAlert("No se realizó la operación de cobranza y finiquito de venta");
                return;
            }

            const tipoPagoNormalizado = (data2.tipopago || "").trim().toUpperCase();
            if (tipoPagoNormalizado === "CRÉDITO A CLIENTE" || tipoPagoNormalizado === "CREDITO CLIENTE") {
                const claveClienteCredito = (data2.clavecliente || "").trim();
                if (!claveClienteCredito) {
                    handleOpenAlert("No se registró la cuenta por cobrar: la venta a crédito requiere un cliente registrado y cargado. Seleccione un cliente y vuelva a cobrar.", "warning");
                } else {
                    const responseCredito = await PostRequest({
                        url: apiCreditoClientesMigrarVenta,
                        body: {
                            clavecliente: claveClienteCredito,
                            nombrecliente: data2.razonsocial,
                            remision: data2.remision,
                            pc: data2.pc,
                            foliocortecaja: data2.foliocortecaja,
                            subtotal: data2.subtotal,
                            iva: data2.iva,
                            descuento: data2.totaldescuento,
                            total: data2.total,
                            efectivo: data2.totalefectivo,
                            cambio: data2.totalcambio,
                            montoabonoinicial: data2.montoabonoinicial,
                            efectivoabonoinicial: data2.efectivoabonoinicial,
                            formapagoabonoinicial: data2.formapagoabonoinicial,
                            referenciaabonoinicial: data2.referenciaabonoinicial,
                            observacionabonoinicial: data2.observacionabonoinicial
                        },
                        loader: "Registrando crédito a cliente..."
                    });

                    if (responseCredito.hasError) {
                        handleOpenAlert("Venta terminada, pero no se registró la cuenta por cobrar: " + responseCredito.message, "warning");
                    }
                }
            }

            setStatusKeyActions(true);
            setOpenModalCobrarVenta(false);
            setStatusCloseModal(true);

            await handleImprimirTicket(folioActual, parametrosCajaForm.caja);

            const incrementoResponse = await GetRequest({
                url: apiIncrementaVentasFolio.replace("{caja}", parametrosCajaForm.caja),
                loader: "Incrementando folio ventas por caja...",
            });

            if (incrementoResponse.hasError) {
                handleOpenAlert("Error al incrementar folio: " + incrementoResponse.message);
            }

            const apiUrlEliminar = apiEliminarVenta
                .replace("{remision}", folioActual)
                .replace("{pc}", parametrosCajaForm.caja.trim())
                .replace("{tipoventa}", "VENTA");

            await GetRequest({ url: apiUrlEliminar });

            await handleObtenerParametrosCaja();

            const dataVentas = await handleObtenerVentas("VENTA", parametrosCajaForm.folioventa, parametrosCajaForm.caja);
            setListaRemisionTemporal(dataVentas ?? []);
            setVentaTotales(getVentaTotalesForm());
            setClienteForm({});
            setPartidaSeleccionada([]);
            setListaVenta([]);
            setStatusCobroApartado(false);

            await handleRetotalizarCuentaVenta(dataVentas ?? []);
            setStatusKeyActions(false);
        } catch (error) {
            handleOpenAlert("Ocurrió un error al procesar la venta: " + error);
            setStatusKeyActions(false);
        } finally {
            terminoVentaRef.current = false;
        }
    };

    const handleGuardarVentaComoCotizacion = async () => {
        if (terminoVentaRef.current) return;
        terminoVentaRef.current = true;

        try {
            if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
                handleOpenAlert("Caja no configurada");
                return;
            }

            const remisionActual = parametrosCajaForm.folioventa;
            const pc = parametrosCajaForm.caja;

            const data = {
                remision: remisionActual,
                pc: pc
            };

            setStatusWaiting(true);
            const response = await PostRequest({
                url: apiTerminarCotizacion,
                body: data,
                loader: "Convirtiendo venta a cotización"
            });
            setStatusWaiting(false);

            if (response.hasError) {
                handleOpenAlert(response.message);
                return;
            }

            if (!response.result) {
                handleOpenAlert("No se guardó la cotización");
                return;
            }

            const folioCotizacion = response.result;

            await handleObtenerParametrosCaja();

            await handleClickEliminarVenta();
            await handleInicializarVentanaVentas();

            await handleImprimirTicket(folioCotizacion, pc, {
                tipoDocumento: "COTIZACION",
                etiquetaFolio: "Cotizacion",
                nombreImpresora: parametrosCajaForm.nombreimpresoracotizaciones?.trim() || null,
            });

            setStatusKeyActions(false);
            handleOpenAlert("Cotización guardada e impresa correctamente");
        } catch (error) {
            handleOpenAlert("Ocurrió un error al guardar la cotización: " + error);
        } finally {
            terminoVentaRef.current = false;
        }
    };

    const MontoEnLetra = async (monto) => {
        if (monto < 0)
            return "Valor negativo no válido";

        if (monto === 0)
            return "";

        const response = await GetRequest({
            url: apiMontoEnLetra.replace('{monto}', monto),
        });
        //setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return "";
        }

        if (response.result === undefined)
            return "";

        return response.result;
    };

    //solo funcionalidad para usaurios estandard
    const handleAplicarDescuentoAClienteVenta = async (data) => {
        let clavecliente = data.clavecliente;
        let razonsocial = data.razonsocial;
        let porcentajedescuento = data.porcentajedescuento;

        if (clavecliente === undefined) {
            handleOpenAlert("Cliente no válido");
            return;
        }

        if (clavecliente.length === 0) {
            handleOpenAlert("Cliente no válido");
            return;
        }

        if (ventaTotales.totalDescuento > 0) {
            handleOpenAlert("Cliente y descuento ya aplicado");
            return;
        }

        let url = apiAplicaDescuentoAClienteVenta.replace("{remision}", parametrosCajaForm.folioventa);
        url = url.replace("{pc}", parametrosCajaForm.caja);
        url = url.replace("{clavecliente}", clavecliente);
        url = url.replace("{razonsocial}", razonsocial);
        url = url.replace("{porcentaje}", porcentajedescuento);

        setStatusWaiting(true);
        const response = await GetRequest({
            url: url,
            loader: "Aplicando descuento a cliente"
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return "";
        }

        if (response.result === undefined)
            return "";

        handleClickRefrescarDatosVenta();
        setStatusKeyActions(false);
    };

    const handleReimprimirTicket = async () => {
        let RemisionX = parametrosCajaForm.folioventa - 1;
        let CajaX = parametrosCajaForm.caja;
        //Hay que regenerar este método urgentemente 

        if (RemisionX === 0)
            return;

        let url = apiObtenerRemisionVenta.replace("{remision}", RemisionX)
        url = url.replace("{caja}", CajaX)

        setStatusWaiting(true);
        const response = await GetRequest({
            url: url,
            loader: "Obteniendo remisión de venta en caja"
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return "";
        }

        if (response.result === undefined)
            return "";

        setDataRemision(response.result ? response.result : [])
        setOpenModalImpresion(true);
    };

    const [listaImpresoras, setListaImpresoras] = useState([]);
    const handleObtenerListaImpresiorasLan = async () => {
        try {
            let pc = parametrosCajaForm.caja.trim();
            const response = await fetch(`http://localhost:4000/api/impresoras`, {
                method: "GET"
            });

            if (!response.ok) {
                return "";
            }

            const data = await response.json();
            const printers = Array.isArray(data) ? data : data?.result ?? [];
            setListaImpresoras(printers);
        } catch {
            setListaImpresoras([]);
        }
    };

    const handleImprimirTicketEscapeCommand = async (remision, caja, opciones = {}) => {
        if (isNullOrEmpty(remision) || remision === 0 || isNullOrEmpty(caja)) return;

        await handleAbrirCajonDinero();

        let url = apiObtenerRemisionVenta.replace("{remision}", remision);
        url = url.replace("{caja}", caja);

        setStatusWaiting(true);
        const response = await GetRequest({
            url: url,
            loader: "Obteniendo remision de venta en caja",
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return "";
        }

        if (response.result === undefined) return "";

        setDataTicket(response.result || {});

        try {
            const usaFormatoClasico = !layoutTieneObjetos(parametrosCajaForm)
                && (!opciones.tipoDocumento || opciones.tipoDocumento === "VENTA");
            const { partes } = usaFormatoClasico
                ? buildTicketVentaClasicoParts({
                    dataTicket: response.result,
                    parametrosCajaForm,
                    esReimpresion: Boolean(opciones.esReimpresion),
                })
                : buildTicketVentaParts({
                    dataTicket: response.result,
                    parametrosCajaForm,
                    ...opciones,
                });
            await imprimirTicketEnPrinterTools({
                partes,
                parametrosCajaForm,
                nombreImpresora: opciones.nombreImpresora || null,
            });
            handleOpenAlert("Impresion realizada", "OK");
        } catch (error) {
            handleOpenAlert(`Error en impresion: ${getErrorMessage(error)}`, "error");
        }
    };
    const handleImprimirCorteCajaEscapeCommand = async (data) => {
        if (isNullOrEmpty(data) || data === 0) return;

        const formData = new FormData();
        const textEncoder = new TextEncoder();

        let ticketParts = [textEncoder.encode('\x1B\x40')];

        ticketParts.push(
            textEncoder.encode('\x1B\x61\x01\x1B\x21\x11' + 'CORTE DE CAJA\n'),
            textEncoder.encode('\x1B\x61\x00\x1B\x21\x00' + '-'.repeat(32) + '\n'),
            textEncoder.encode('Caja: ' + (data.pc || "") + '\n'),
            textEncoder.encode('Vendedor: ' + (data.vendedor || "") + '\n'),
            textEncoder.encode('Fecha: ' + (data.fechacorte || "") + '\n'),
            textEncoder.encode('-'.repeat(32) + '\n'),
            textEncoder.encode('-'.repeat(32) + '\n\n\n'),
            textEncoder.encode('Total efectivo: ' + (data.totalefectivo || 0).toFixed(2) + '\n'),
            textEncoder.encode('Total T. debito: ' + (data.totaltarjetadebito || 0).toFixed(2) + '\n'),
            textEncoder.encode('Total T. credito: ' + (data.totaltarjetacredito || 0).toFixed(2) + '\n'),
            textEncoder.encode('Total transferencia: ' + (data.totaltransferencia || 0).toFixed(2) + '\n'),
            textEncoder.encode('Total apartados: ' + (data.totalapartados || 0).toFixed(2) + '\n'),
            textEncoder.encode('Abonos apartados: ' + (data.totalabonosapartados || 0).toFixed(2) + '\n'),
            textEncoder.encode('Total devoluciones: ' + (data.totaldevoluciones || 0).toFixed(2) + '\n'),
            textEncoder.encode('Total a credito: ' + (data.totalcreditocliente || 0).toFixed(2) + '\n'),
            textEncoder.encode('Total retiros: ' + (data.totalretiros || 0).toFixed(2) + '\n'),
            textEncoder.encode('Total general: ' + (data.totalgeneral || 0).toFixed(2) + '\n\n'),
            textEncoder.encode('-'.repeat(32) + '\n')
        );

        const total = data.totalgeneral || 0;
        const totalEnLetra = await MontoEnLetra(total);
        ticketParts.push(textEncoder.encode('Total venta en letra: ' + (totalEnLetra || "") + '\n'));
        // Añadir Pie de ticket configurado
        const pieConfigurado = (parametrosCajaForm.pieticket || "");
        if (pieConfigurado.length > 0) {
            ticketParts.push(textEncoder.encode('\x1B\x61\x01' + pieConfigurado + '\n'));
            ticketParts.push(textEncoder.encode('\x1B\x61\x00' + '-'.repeat(32) + '\n'));
        }

        ticketParts.push(textEncoder.encode('\x1B\x61\x01' + 'Corte de caja estandarizado!\n\n\n\n\n'));
        ticketParts.push(textEncoder.encode('\x1D\x56\x00'));

        const totalLength = ticketParts.reduce((sum, part) => sum + part.length, 0);
        const finalTicket = new Uint8Array(totalLength);
        let offset = 0;
        ticketParts.forEach(part => {
            finalTicket.set(part, offset);
            offset += part.length;
        });

        formData.append("ticket", new Blob([finalTicket], { type: "application/octet-stream" }));
        formData.append("printerName", parametrosCajaForm.nombreimpresoraventas.trim());

        const logoBase64 = parametrosCajaForm?.logo;
        if (logoBase64) {
            try {
                const binary = atob(logoBase64);
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
                formData.append("logo", new Blob([bytes], { type: "image/png" }), "logocliente.png");
            } catch (err) {
                handleOpenAlert("Logo no disponible: " + getErrorMessage(err), "error");
            }
        }

        try {
            let pc = parametrosCajaForm.caja.trim();
            const response2 = await fetch(`http://localhost:4000/api/imprimirticket`, {
                method: "POST",
                body: formData,
            });

            if (!response2.ok) {
                handleOpenAlert(`Error en envío de impresión: ${response2.statusText}`);
                return;
            }

            handleOpenAlert("Impresión realizada", "OK");
        } catch (error) {
            handleOpenAlert(`Error en impresión: ${getErrorMessage(error)}`, "error");
        }
    };

    const handleAbrirCajonDinero = async (printerNameOverride) => {
        try {
            const printerName = (printerNameOverride || parametrosCajaForm.nombreimpresoraventas || "").trim();
            if (!printerName) return false;

            const formData = new FormData();
            formData.append("ticket", new Blob([COMANDO_APERTURA_CAJON], { type: "application/octet-stream" }));
            formData.append("printerName", printerName);

            const response = await fetch(`http://localhost:4000/api/imprimirticket`, {
                method: "POST",
                body: formData,
            });

            return response.ok;
        } catch {
            return false;
        }
    };

    const handleImprimirTicket = async (ticket = 0, caja, opciones = {}) => {
        try {
            if (isNullOrEmpty(ticket) || ticket === 0 || isNullOrEmpty(caja)) return;
            await handleImprimirTicketEscapeCommand(ticket, caja, opciones);
            setStatusKeyActions(false);
        } catch (error) {
            handleOpenAlert(`Error en impresion: ${getErrorMessage(error)}`, "error");
        }
    };

    const handleImprimirTicketApartados = async (cabecero, detalles) => {
        
        try {
            if (!cabecero || !Array.isArray(detalles) || detalles.length === 0) {
                handleOpenAlert(
                    "No hay datos suficientes para imprimir el apartado.",
                    "error"
                );
                return;
            }

            if (!cabecero.folioapartado) {
                handleOpenAlert(
                    "El apartado no tiene un folio válido.",
                    "error"
                );
                return;
            }

            const numero = (valor) => {
                const n = Number(valor);
                return Number.isFinite(n) ? n : 0;
            };

            const redondear = (valor) =>
                Math.round((valor + Number.EPSILON) * 100) / 100;

            const obtenerClave = (articulo) =>
                String(
                    articulo.sClaveArticulo ??
                    articulo.clavearticulo ??
                    articulo.claveArticulo ??
                    ""
                ).trim().toUpperCase();

            let totalAbonado = 0;
            let totalIVA = 0;
            let subTotal = 0;
            let totalImporteArticulos = 0;

            const detallesFormateados = [];

            // ---------------------------------------------------------
            // 1. OBTENER CLAVES ÚNICAS DE ARTÍCULOS
            // ---------------------------------------------------------

            const clavesArticulos = [
                ...new Set(
                    detalles.map(obtenerClave).filter(Boolean)
                ),
            ];

            // ---------------------------------------------------------
            // 2. CONSULTAR INFORMACIÓN FISCAL DE CADA ARTÍCULO
            // ---------------------------------------------------------
            const articulosData = await Promise.all(
                clavesArticulos.map(async (clave) => {
                    try {
                        return await handleObtenerArticuloByClave(clave);
                    } catch (error) {
                        console.warn(
                            "[APARTADOS] Error al consultar artículo:",
                            clave,
                            getErrorMessage(error)
                        );
                        return null;
                    }
                })
            );

            const articulosMap = {};

            clavesArticulos.forEach((clave, indice) => {
                articulosMap[clave] = articulosData[indice];
            });

            // ---------------------------------------------------------
            // 3. NORMALIZAR DETALLES Y CALCULAR IMPORTES
            // ---------------------------------------------------------

            for (const articulo of detalles) {
                const claveArt = obtenerClave(articulo);
                const data = articulosMap[claveArt];

                if (!claveArt || !data) {
                    throw new Error(
                        `No fue posible obtener los datos fiscales del artículo ${claveArt || "sin clave"}.`
                    );
                }

                const cantidad = numero(
                    articulo.dCantidadArticulo ??
                    articulo.cantidadarticulo ??
                    articulo.cantidad
                );

                const pUnit = numero(
                    articulo.dCostoArticulo ??
                    articulo.costoarticulo ??
                    articulo.pUnit
                );

                const desc = numero(
                    articulo.dMontoDescuentoArticulo ??
                    articulo.montodescuentoarticulo ??
                    articulo.desc
                );

                // Conservamos el cálculo original del importe.
                const importeVenta = redondear(pUnit * cantidad);

                const abono = redondear(numero(
                    articulo.dMontoAbonado ??
                    articulo.montoabonado ??
                    articulo.abono
                ));

                // -----------------------------------------------------
                // 4. INFORMACIÓN FISCAL DEL ARTÍCULO
                // -----------------------------------------------------

                const ivaventa = String(
                    data.ivaventa ?? ""
                ).trim().toUpperCase();

                const exentoiva = String(
                    data.exentoiva ?? "NO"
                ).trim().toUpperCase();

                const porcentajeIVA = numero(data.porcentajeiva);

                // Normalización: admite 16 o 0.16 para representar 16%.
                const tasaIVA =
                    porcentajeIVA > 1
                        ? porcentajeIVA / 100
                        : porcentajeIVA;

                const llevaIVA =
                    ivaventa === "SI" &&
                    exentoiva !== "SI" &&
                    tasaIVA > 0;

                let ivaPartida = 0;
                let subPartida = abono;

                // El abono se considera importe con IVA incluido.
                if (llevaIVA && abono > 0) {
                    subPartida = redondear(
                        abono / (1 + tasaIVA)
                    );

                    ivaPartida = redondear(
                        abono - subPartida
                    );
                }

                // -----------------------------------------------------
                // 5. ACUMULACIÓN DE TOTALES
                // -----------------------------------------------------

                totalAbonado += abono;
                totalIVA += ivaPartida;
                subTotal += subPartida;
                totalImporteArticulos += importeVenta;

                detallesFormateados.push({
                    clavearticulo: claveArt,
                    descripcion:
                        articulo.descripcion ??
                        articulo.sDescripcion ??
                        data.descripcion ??
                        "",

                    vendedorpreventa:
                        articulo.vendedorpreventa || "",

                    almacenexhibidor:
                        articulo.almacenexhibidor || "",

                    cantidad,
                    medida:
                        articulo.medida ??
                        articulo.dMedida ??
                        0,

                    pUnit,
                    desc,
                    importeVenta,
                    abono,
                    ivaPartida,
                    llevaIVA,
                    porcentajeIVA,
                    subPartida,
                });
            }

            // ---------------------------------------------------------
            // 6. REDONDEAR TOTALES
            // ---------------------------------------------------------

            totalAbonado = redondear(totalAbonado);
            totalIVA = redondear(totalIVA);
            subTotal = redondear(subTotal);
            totalImporteArticulos = redondear(totalImporteArticulos);

            // ---------------------------------------------------------
            // 7. NORMALIZAR CABECERO
            // ---------------------------------------------------------

            const cabeceroNormalizado = {
                ...cabecero,

                concepto: String(
                    cabecero.concepto ?? ""
                ).trim(),

                grupo: String(
                    cabecero.grupo ?? ""
                ).trim(),

                montoabonoletra:
                    cabecero.montoabonoletra ||
                    cabecero.montoletra ||
                    "",
            };

            const totalesApartado = {
                subTotal,
                totalIVA,
                totalImporteArticulos,
                totalAbonado,
            };

            // ---------------------------------------------------------
            // 8. CONFIGURACIÓN DE IMPRESIÓN
            // ---------------------------------------------------------

            const printerName =
                parametrosCajaForm.nombreimpresoraapartados?.trim() || null;

            const copias = [
                {
                    titulo: "COPIA ALMACENAMIENTO",
                    esCopiaCliente: false,
                },
                {
                    titulo: "COPIA CLIENTE",
                    esCopiaCliente: true,
                },
            ];

            const usaEsquema =
                layoutTieneObjetos(parametrosCajaForm);

            // ---------------------------------------------------------
            // 9. CONSTRUIR AMBAS COPIAS
            // ---------------------------------------------------------

            const trabajosImpresion = copias.map((copia) => {
                const opciones = {
                    cabecero: cabeceroNormalizado,
                    detalles: detallesFormateados,
                    totales: totalesApartado,
                    parametrosCajaForm,
                    titulo: copia.titulo,
                    esCopiaCliente: copia.esCopiaCliente,
                };

                const resultado = usaEsquema
                    ? buildTicketApartadoPersonalizadoParts(opciones)
                    : buildTicketApartadoClasicoParts(opciones);
        
                if (
                    !Array.isArray(resultado?.partes) ||
                    resultado.partes.length === 0
                ) {
                    throw new Error(
                        `No se pudo construir ${copia.titulo}.`
                    );
                }

                return {
                    titulo: copia.titulo,
                    partes: resultado.partes,
                };
            });

            // ---------------------------------------------------------
            // 10. APERTURA DE CAJÓN
            // ---------------------------------------------------------

            await handleAbrirCajonDinero();

            // ---------------------------------------------------------
            // 11. IMPRIMIR AMBAS COPIAS
            // ---------------------------------------------------------

            for (const trabajo of trabajosImpresion) {
                await imprimirTicketEnPrinterTools({
                    partes: trabajo.partes,
                    parametrosCajaForm,
                    nombreImpresora: printerName,
                });
            }

            handleOpenAlert(
                "Impresión de apartados correcta",
                "success"
            );

            setStatusKeyActions(false);

        } catch (error) {
            handleOpenAlert(
                `Error en impresión de apartados: ${getErrorMessage(error)}`,
                "error"
            );
        }
    };

    const handleImprimirReporteVentasAlmacen = async () => {

        // Depuración: mostrar datos recibidos

        if (!listaVentasAgrupadas || listaVentasAgrupadas.length === 0) {
            handleOpenAlert("No hay datos para imprimir el reporte");
            return;
        }

        const formData = new FormData();
        const textEncoder = new TextEncoder();

        let ticketParts = [textEncoder.encode('\x1B\x40')]; // Inicializa impresora

        // Encabezado
        ticketParts.push(
            textEncoder.encode('\x1B\x61\x01\x1B\x21\x11' + 'REPORTE DE VENTAS POR ALMACÉN\n'),
            textEncoder.encode('\x1B\x61\x00\x1B\x21\x00' + '-'.repeat(32) + '\n')
        );

        // Información del almacén y período
        const almacenNombre = almacenSeleccionadoVentas?.almacenexhibidor || "TODOS LOS ALMACENES";
        ticketParts.push(
            textEncoder.encode('Almacén: ' + almacenNombre + '\n'),
            textEncoder.encode('Fecha inicio: ' + getDateStringV2(fechaInicioVentas) + '\n'),
            textEncoder.encode('Fecha fin: ' + getDateStringV2(fechaFinVentas) + '\n'),
            textEncoder.encode('-'.repeat(32) + '\n')
        );

        // Encabezado de columnas
        ticketParts.push(
            textEncoder.encode('CANT DESCRIPCIÓN          PRECIO TOTAL\n'),
            textEncoder.encode('-'.repeat(32) + '\n')
        );

        // Detalles de ventas
        let totalGeneral = 0;
        listaVentasAgrupadas.forEach((venta, index) => {
            const cantidad = venta.cantidadvendida || 0;
            const precio = venta.costoventa || 0;
            const totalLinea = cantidad * precio;
            totalGeneral += totalLinea;

            // Dividir descripción en dos líneas si es necesario
            const descripcionCompleta = (venta.descripcion || "");
            const primeraLinea = descripcionCompleta.substring(0, 20);
            const segundaLinea = descripcionCompleta.length > 20 ? descripcionCompleta.substring(20, 40) : "";

            // Primera línea: cantidad, primera parte de descripción, precio, total
            ticketParts.push(textEncoder.encode(
                String(cantidad).padStart(3, ' ') + ' ' +
                primeraLinea.padEnd(20, ' ') + ' ' +
                '$' + String(precio.toFixed(2)).padStart(5, ' ') + ' ' +
                '$' + String(totalLinea.toFixed(2)).padStart(5, ' ') + '\n'
            ));

            // Segunda línea: solo la segunda parte de descripción (si existe)
            if (segundaLinea) {
                ticketParts.push(textEncoder.encode(
                    '      ' + // 6 espacios para alinear con el campo de descripción (después de "CANT ")
                    segundaLinea + '\n'
                ));
            }
        });

        // Total
        ticketParts.push(
            textEncoder.encode('-'.repeat(32) + '\n'),
            textEncoder.encode('\x1B\x61\x00TOTAL: '),
            textEncoder.encode('\x1B\x61\x02$' + totalGeneral.toFixed(2) + '\n'),
            textEncoder.encode('\x1B\x61\x01' + 'Reporte generado por SizeSoftX\n'),
            textEncoder.encode('\n\n\n\n\n\n\n\x1D\x56\x00')
        );

        const totalLength = ticketParts.reduce((sum, part) => sum + part.length, 0);
        const finalTicket = new Uint8Array(totalLength);
        let offset = 0;
        ticketParts.forEach(part => {
            finalTicket.set(part, offset);
            offset += part.length;
        });

        formData.append("ticket", new Blob([finalTicket], { type: "application/octet-stream" }));
        formData.append("printerName", parametrosCajaForm.nombreimpresoraventas.trim());

        const logoBase64 = parametrosCajaForm?.logo;
        if (logoBase64) {
            try {
                const binary = atob(logoBase64);
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
                formData.append("logo", new Blob([bytes], { type: "image/png" }), "logocliente.png");
            } catch (err) {
                handleOpenAlert("Logo no disponible: " + getErrorMessage(err), "error");
            }
        }

        try {
            const response2 = await fetch(`http://localhost:4000/api/imprimirticket`, {
                method: "POST",
                body: formData,
            });
            setStatusWaiting(false);

            if (!response2.ok) {
                const errorData = await response2.json();
                handleOpenAlert("Error al imprimir: " + (errorData.message || response2.statusText),"error");
            }
        } catch (error) {
            setStatusWaiting(false);
            handleOpenAlert("Error en la conexión de impresión: " + getErrorMessage(error), "error");
        }
    };

    const normalizarTicketAbonoApartado = (data = {}) => ({
        ...data,
        iAbono: data.iAbono ?? data.abono ?? data.iabono ?? 0,
        iFolioApartado: data.iFolioApartado ?? data.folioapartado ?? 0,
        iIDPartida: data.iIDPartida ?? data.idpartida ?? 0,
        dMontoAbono: data.dMontoAbono ?? data.montoabono ?? 0,
        dteFechaRegistro: data.dteFechaRegistro ?? data.fecharegistro ?? data.fechaabono ?? new Date().toISOString(),
        sTipoPago: data.sTipoPago ?? data.tipopago ?? "",
        sSerialTarjetaChequeVale: data.sSerialTarjetaChequeVale ?? data.serialtarjetachequevale ?? "",
        sNombreCliente: data.sNombreCliente ?? data.nombrecliente ?? "",
        sDescripcionArticulo: data.sDescripcionArticulo ?? data.descripcionarticulo ?? data.descripcion ?? "",
        sClaveArticulo: data.sClaveArticulo ?? data.clavearticulo ?? "",
        dMedida: data.dMedida ?? data.medida ?? 0,
        dCantidadArticulo: data.dCantidadArticulo ?? data.cantidadarticulo ?? data.cantidad ?? 0,
        dCostoArticulo: data.dCostoArticulo ?? data.costoarticulo ?? 0,
        dMontoDescuentoArticulo: data.dMontoDescuentoArticulo ?? data.montodescuentoarticulo ?? 0,
        dTotalAbonado: data.dTotalAbonado ?? data.totalabonado ?? 0,
        sMontoEnLetra: data.sMontoEnLetra ?? data.montoenletra ?? "",
        EncabezadoTicket: data.EncabezadoTicket ?? data.encabezado ?? data.encabezadoticket ?? "",
        PieDeTicket: data.PieDeTicket ?? data.pie ?? data.pieticket ?? ""
    });

    const handleImprimirTicketAbono = async (abonoData) => {
        //Abonos apartados
        if (!abonoData || isNullOrEmpty(abonoData)) {
            handleOpenAlert("No hay datos del abono para imprimir");
            return false;
        }

        try {
            await handleAbrirCajonDinero();
            const {
                iAbono,
                iFolioApartado,
                iIDPartida,
                dMontoAbono,
                dteFechaRegistro,
                sTipoPago,
                sSerialTarjetaChequeVale,
                sNombreCliente,
                sDescripcionArticulo,
                sClaveArticulo,
                dMedida,
                dCantidadArticulo,
                dCostoArticulo,
                dMontoDescuentoArticulo,
                dTotalAbonado,
                sMontoEnLetra,
                EncabezadoTicket,
                PieDeTicket
            } = normalizarTicketAbonoApartado(abonoData);

            const costoUnit = Number(dCostoArticulo) || 0;
            const cantidadArt = Number(dCantidadArticulo) || 0;
            const descuentoArt = Number(dMontoDescuentoArticulo) || 0;
            const importeTotalArticulo = costoUnit * cantidadArt;
            const totalAbonadoAcumulado = Number(dTotalAbonado) || 0;
            const restanteApartado = importeTotalArticulo - totalAbonadoAcumulado;

            if (layoutTieneObjetos(parametrosCajaForm)) {
                const { partes } = buildTicketAbonoApartadoParts({
                    abono: normalizarTicketAbonoApartado(abonoData),
                    parametrosCajaForm,
                    formatearImporte: NumberFormat$,
                });

                await imprimirTicketEnPrinterTools({
                    partes,
                    parametrosCajaForm,
                    nombreImpresora:
                        (parametrosCajaForm.nombreimpresoraapartados || "").trim() || null,
                });

                handleOpenAlert("Impresion abono realizada", "OK");
                return true;
            }


            const textEncoder = new TextEncoder();
            const parts = [];

            const logoBase64 = parametrosCajaForm?.logo;
            let logoBlob = null;
            if (logoBase64) {
                try {
                    const binary = atob(logoBase64);
                    const bytes = new Uint8Array(binary.length);
                    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
                    logoBlob = new Blob([bytes], { type: "image/png" });
                } catch (err) {
                    console.warn("Logo no disponible:", err);
                }
            }

            parts.push(textEncoder.encode('\x1B\x40'));
            parts.push(textEncoder.encode('\x1B\x4B\x60'));
            parts.push(textEncoder.encode('\x1B\x33\x00'));
            parts.push(textEncoder.encode('\x1B\x61\x01\x1B\x21\x30' + 'RECIBO DE ABONO\n'));
            parts.push(textEncoder.encode('\x1B\x21\x00'));
            parts.push(textEncoder.encode('\x1B\x32'));
            parts.push(textEncoder.encode('-'.repeat(32) + '\n'));

            const encabezado = (EncabezadoTicket || parametrosCajaForm.encabezadoticket || "").trim();
            if (encabezado.length > 0) {
                parts.push(textEncoder.encode('\x1B\x61\x01' + encabezado + '\n'));
                parts.push(textEncoder.encode('\x1B\x61\x00' + '-'.repeat(32) + '\n'));
            }

            parts.push(textEncoder.encode('\x1B\x61\x00'));
            parts.push(encodeTicketDatoClave(textEncoder, 'Folio Apartado: ' + (iFolioApartado || "") + '\n'));
            parts.push(textEncoder.encode('Partida       : ' + (iIDPartida || "") + '\n'));
            parts.push(textEncoder.encode('Folio Abono   : ' + (iAbono || "") + '\n'));
            parts.push(encodeTicketDatoClave(textEncoder, 'Fecha         : ' + (dteFechaRegistro ? new Date(dteFechaRegistro).toLocaleString() : new Date().toLocaleString()) + '\n'));
            parts.push(textEncoder.encode('-'.repeat(32) + '\n'));

            parts.push(textEncoder.encode('\x1B\x61\x01\x1B\x21\x30'));
            parts.push(textEncoder.encode('ABONO: ' + NumberFormat$(dMontoAbono) + '\n'));
            parts.push(textEncoder.encode('\x1B\x21\x00'));

            if (sTipoPago) {
                parts.push(textEncoder.encode('Tipo Pago : ' + sTipoPago + '\n'));
            }
            if (sSerialTarjetaChequeVale) {
                parts.push(textEncoder.encode('Referencia : ' + sSerialTarjetaChequeVale + '\n'));
            }

            parts.push(textEncoder.encode('-'.repeat(32) + '\n'));

            parts.push(textEncoder.encode('\x1B\x61\x01\x1B\x21\x30'));
            parts.push(textEncoder.encode('DATOS DEL CLIENTE\n'));
            parts.push(textEncoder.encode('\x1B\x21\x00'));
            parts.push(encodeTicketDatoClave(textEncoder, 'Cliente: ' + (sNombreCliente || "N/D") + '\n'));

            parts.push(textEncoder.encode('-'.repeat(32) + '\n'));

            parts.push(textEncoder.encode('\x1B\x61\x01\x1B\x21\x30'));
            parts.push(textEncoder.encode('ARTICULO ABONADO\n'));
            parts.push(textEncoder.encode('\x1B\x21\x00'));
            parts.push(textEncoder.encode('Clave     : ' + (sClaveArticulo || "N/D") + '\n'));
            parts.push(textEncoder.encode('Descrip.  : ' + ((sDescripcionArticulo || "N/D").substring(0, 25)) + '\n'));
            parts.push(textEncoder.encode('Medida    : ' + (dMedida || 0) + '\n'));
            parts.push(textEncoder.encode('Cantidad  : ' + (dCantidadArticulo || 0) + '\n'));
            parts.push(textEncoder.encode('Importe  : ' + NumberFormat$(costoUnit) + '\n'));
            parts.push(textEncoder.encode('Desc    : ' + NumberFormat$(descuentoArt) + '\n'));

            parts.push(textEncoder.encode('-'.repeat(32) + '\n'));
            parts.push(textEncoder.encode('Total articulo: ' + NumberFormat$(importeTotalArticulo) + '\n'));
            parts.push(textEncoder.encode('Total Abonado: ' + NumberFormat$(totalAbonadoAcumulado) + '\n'));
            parts.push(textEncoder.encode('Restante: ' + NumberFormat$(restanteApartado) + '\n'));

            if (sMontoEnLetra) {
                parts.push(textEncoder.encode('Son: ' + sMontoEnLetra + '\n'));
            }

            parts.push(textEncoder.encode('-'.repeat(32) + '\n'));
            parts.push(textEncoder.encode('\x1B\x61\x01\x1B\x45\x01' + 'POLÍTICA DE CAMBIOS (15 DÍAS)\n' + '\x1B\x45\x00'));
            parts.push(textEncoder.encode('\x1B\x61\x00' + 'Ticket físico indispensable.\n'));
            parts.push(textEncoder.encode('Artículos sin uso, con etiquetas\ny empaque original.\n'));
            parts.push(textEncoder.encode('No aplica en ofertas. Cambios\nsolo por igual o mayor valor.\n'));
            parts.push(textEncoder.encode('\x1B\x45\x01' + 'NO SE ACEPTAN DEVOLUCIONES.\n' + '\x1B\x45\x00'));
            parts.push(textEncoder.encode('\x1B\x61\x00' + '-'.repeat(32) + '\n'));

            const pieConfigurado = (PieDeTicket || parametrosCajaForm.pieticket || "");
            if (pieConfigurado.length > 0) {
                parts.push(textEncoder.encode('\x1B\x61\x01' + pieConfigurado + '\n'));
                parts.push(textEncoder.encode('\x1B\x61\x00' + '-'.repeat(32) + '\n'));
            }

            parts.push(textEncoder.encode('\x1B\x61\x01'));
            parts.push(textEncoder.encode('Abono registrado\n'));
            parts.push(textEncoder.encode('Gracias por su preferencia!\n\n\n'));

            parts.push(textEncoder.encode('\x1D\x56\x00'));

            const ticketLength = parts.reduce((sum, part) => sum + part.length, 0);
            const ticketData = new Uint8Array(ticketLength);
            let offset = 0;
            parts.forEach(part => {
                ticketData.set(part, offset);
                offset += part.length;
            });

            const printerName = parametrosCajaForm.nombreimpresoraapartados?.trim() || "";
            const ticketFormData = new FormData();
            ticketFormData.append("ticket", new Blob([ticketData], { type: "application/octet-stream" }));
            ticketFormData.append("printerName", printerName);
            if (logoBlob) {
                ticketFormData.append("logo", logoBlob, "logocliente.png");
            }

            const response = await fetch(`http://localhost:4000/api/imprimirticket`, {
                method: "POST",
                body: ticketFormData,
            });

            if (!response.ok) {
                handleOpenAlert(`Error al imprimir ticket de abono: ${response.statusText}`,"error");
                return false;
            }

            handleOpenAlert("Ticket de abono impreso correctamente", "OK");
            return true;
        } catch (error) {
            handleOpenAlert("Error al imprimir ticket de abono: " + getErrorMessage(error), "error");
            return false;
        }
    };

    const handleReimprimirAbonoApartado = async (abonoSeleccionado) => {
        if (!abonoSeleccionado || isNullOrEmpty(abonoSeleccionado)) {
            handleOpenAlert("No hay abono seleccionado para reimprimir");
            return;
        }

        try {
            const {
                iabono,
                folioapartado,
                idpartida,
                montoabono,
                fechaabono,
                clavearticulo,
                descripcion,
                medida,
                cantidad,
                nombrecliente
            } = abonoSeleccionado;

            const textEncoder = new TextEncoder();

            const costoUnitarioReimp = Number(abonoSeleccionado.costoarticulo) || 0;
            const cantidadArticuloReimp = Number(abonoSeleccionado.cantidad) || 0;
            const totalArticuloReimp = Number(abonoSeleccionado.totalarticulo) || (costoUnitarioReimp * cantidadArticuloReimp);
            const descuentoReimp = Number(dataEstadoCuentaApartado?.apartados?.[0]?.montodescuentoarticulo) || 0;
            const totalAbonadoReimp = Number(dataEstadoCuentaApartado?.totalabonado) || 0;
            const restanteReimp = totalArticuloReimp - totalAbonadoReimp;

            console.log("[SizeSoftX] REIMPRESION ABONO - DATOS ORIGINALES", {
                abonoSeleccionado,
                fecharegistro: abonoSeleccionado?.fecharegistro,
                fechaabono: abonoSeleccionado?.fechaabono,
                dteFechaRegistro: abonoSeleccionado?.dteFechaRegistro,
            });

            // Reimpresion de abono con esquema personalizado.
            // Conserva los mismos importes del formato clasico.
            if (layoutTieneObjetos(parametrosCajaForm)) {

                const abonoNormalizado = normalizarTicketAbonoApartado({
                    ...abonoSeleccionado,

                    montodescuentoarticulo: descuentoReimp,
                    totalabonado: totalAbonadoReimp,

                    encabezadoticket: parametrosCajaForm.encabezadoticket,
                    pieticket: parametrosCajaForm.pieticket,
                });

                const { partes } = buildTicketAbonoApartadoParts({
                    abono: abonoNormalizado,
                    parametrosCajaForm,
                    formatearImporte: NumberFormat$,
                    esReimpresion: true,
                    totalArticuloReimpresion: totalArticuloReimp,
                });

                await imprimirTicketEnPrinterTools({
                    partes,
                    parametrosCajaForm,
                    nombreImpresora:
                        (parametrosCajaForm.nombreimpresoraapartados || "").trim() || null,
                });

                handleOpenAlert(
                    "Ticket de abono reimpreso correctamente",
                    "OK"
                );

                return;
            }

            const construirCuerpoAbono = () => {
                const parts = [
                    textEncoder.encode('\x1B\x40'),
                    textEncoder.encode('\x1B\x4B\x30'),
                ];

                parts.push(textEncoder.encode('\x1B\x33\x00'));
                parts.push(textEncoder.encode('\x1B\x61\x01\x1B\x21\x00' + 'RECIBO DE ABONO\n'));
                parts.push(textEncoder.encode('\x1B\x32'));
                parts.push(textEncoder.encode('\x1B\x61\x00\x1B\x21\x00' + '-'.repeat(32) + '\n'));

                const encabezado = (parametrosCajaForm.encabezadoticket || "").trim();
                if (encabezado.length > 0) {
                    parts.push(textEncoder.encode('\x1B\x61\x01' + encabezado + '\n'));
                    parts.push(textEncoder.encode('\x1B\x61\x00\x1B\x21\x00' + '-'.repeat(32) + '\n'));
                }

                parts.push(
                    textEncoder.encode('Caja: ' + (parametrosCajaForm.caja || "") + '\n'),
                    encodeTicketDatoClave(textEncoder, 'Folio Apartado: ' + (folioapartado || "") + '\n'),
                    textEncoder.encode('Folio Abono: ' + (iabono || "") + '\n'),
                    textEncoder.encode('Partida: ' + (idpartida || "") + '\n'),
                    encodeTicketDatoClave(textEncoder, 'Fecha: ' + (fechaabono || new Date().toLocaleString()) + '\n'),
                    encodeTicketDatoClave(textEncoder, 'Cliente: ' + (nombrecliente || "No especificado") + '\n'),
                    textEncoder.encode('-'.repeat(32) + '\n')
                );

                if (clavearticulo || descripcion) {
                    parts.push(textEncoder.encode('\x1B\x45\x01' + (descripcion || "Artículo") + '\x1B\x45\x00\n'));
                    parts.push(textEncoder.encode('Clave: ' + (clavearticulo || "N/A") + '\n'));
                    parts.push(textEncoder.encode('Cantidad: ' + (cantidad || "1") + ' - Talla: ' + (medida || "N/A") + '\n'));
                    parts.push(textEncoder.encode('.'.repeat(32) + '\n'));
                }

                parts.push(
                    textEncoder.encode('-'.repeat(32) + '\n'),
                    textEncoder.encode('\x1B\x21\x30'),
                    textEncoder.encode('IMPORTE ABONO: ' + NumberFormat$(montoabono) + '\n'),
                    textEncoder.encode('\x1B\x21\x00'),
                    textEncoder.encode('-'.repeat(32) + '\n'),
                    textEncoder.encode('Descuento: ' + NumberFormat$(descuentoReimp) + '\n'),
                    textEncoder.encode('Total articulo: ' + NumberFormat$(totalArticuloReimp) + '\n'),
                    textEncoder.encode('Total abonado: ' + NumberFormat$(totalAbonadoReimp) + '\n'),
                    textEncoder.encode('Restante: ' + NumberFormat$(restanteReimp) + '\n'),
                    textEncoder.encode('-'.repeat(32) + '\n')
                );

                parts.push(
                    textEncoder.encode('-'.repeat(32) + '\n'),
                    textEncoder.encode('\x1B\x61\x01\x1B\x45\x01' + 'AVISO IMPORTANTE:\n' + '\x1B\x45\x00'),
                    textEncoder.encode('\x1B\x61\x00' + 'Vigencia apartado: 15 días.\n'),
                    textEncoder.encode('Ticket físico indispensable.\n'),
                    textEncoder.encode('\x1B\x45\x01' + 'NO SE ACEPTAN DEVOLUCIONES.\n' + '\x1B\x45\x00'),
                    textEncoder.encode('Artículos sin uso y c/etiqueta.\n'),
                    textEncoder.encode('No aplica en ofertas/promociones.\n'),
                    textEncoder.encode('Conserve este ticket físico.\n'),
                    textEncoder.encode('-'.repeat(32) + '\n')
                );

                const pieConfigurado = (parametrosCajaForm.pieticket || "");
                if (pieConfigurado.length > 0) {
                    parts.push(textEncoder.encode('\x1B\x61\x01' + pieConfigurado + '\n'));
                    parts.push(textEncoder.encode('\x1B\x61\x00\x1B\x21\x00' + '-'.repeat(32) + '\n'));
                }

                parts.push(textEncoder.encode('\n\n\n'));

                return parts;
            };

            const logoBase64 = parametrosCajaForm?.logo;
            let logoBlob = null;
            if (logoBase64) {
                try {
                    const binary = atob(logoBase64);
                    const bytes = new Uint8Array(binary.length);
                    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
                    logoBlob = new Blob([bytes], { type: "image/png" });
                } catch (err) {
                    console.warn("Logo no disponible:", err);
                }
            }

            const printerName = parametrosCajaForm.nombreimpresoraapartados?.trim() || "";

            const ticket = construirCuerpoAbono();
            ticket.push(textEncoder.encode('\n\n\n\n\n'));
            ticket.push(textEncoder.encode('\x1D\x56\x00'));
            const ticketLength = ticket.reduce((sum, part) => sum + part.length, 0);
            const ticketData = new Uint8Array(ticketLength);
            let offset = 0;
            ticket.forEach(part => {
                ticketData.set(part, offset);
                offset += part.length;
            });

            const ticketFormData = new FormData();
            ticketFormData.append("ticket", new Blob([ticketData], { type: "application/octet-stream" }));
            ticketFormData.append("printerName", printerName);
            if (logoBlob) {
                ticketFormData.append("logo", logoBlob, "logocliente.png");
            }

            const response = await fetch(`http://localhost:4000/api/imprimirticket`, {
                method: "POST",
                body: ticketFormData,
            });

            if (!response.ok) {
                handleOpenAlert(`Error al reimprimir ticket de abono: ${response.statusText}`);
                return;
            }

            handleOpenAlert("Ticket de abono reimpreso correctamente", "OK");
        } catch (error) {
            handleOpenAlert("Error al reimprimir ticket de abono: " + getErrorMessage(error), "error");
        }
    };

    const handleImprimirTicketAcuseEntrega = async (entregaData) => {
        if (!entregaData || isNullOrEmpty(entregaData)) {
            handleOpenAlert("No hay datos de entrega para imprimir acuse");
            return false;
        }

        try {
            const {
                iFolioApartado,
                iIDPartida,
                dCostoArticulo,
                dteFechaRegistro,
                sNombreCliente,
                sDescripcionArticulo,
                sClaveArticulo,
                dMedida,
                dCantidadArticulo,
                dTotalAbonado,
                sMontoEnLetra,
                EncabezadoTicket
            } = normalizarTicketAbonoApartado(entregaData);

            if (layoutTieneObjetos(parametrosCajaForm)) {
                const entrega = normalizarTicketAbonoApartado(entregaData);

                const { partes } = buildTicketAcuseEntregaPersonalizadoParts({
                    entrega,
                    parametrosCajaForm,
                    formatearImporte: NumberFormat$,
                });

                await imprimirTicketEnPrinterTools({
                    partes,
                    parametrosCajaForm,
                    nombreImpresora:
                        (parametrosCajaForm.nombreimpresoraapartados || "").trim() || null,
                });

                handleOpenAlert(
                    "Acuse de entrega impreso correctamente",
                    "OK"
                );

                return true;
            }

            const textEncoder = new TextEncoder();
            const parts = [];
            const linea = '-'.repeat(32);

            parts.push(textEncoder.encode('\x1B\x40'));
            parts.push(textEncoder.encode('\x1B\x4B\x60'));
            parts.push(textEncoder.encode('\x1B\x33\x00'));
            parts.push(textEncoder.encode('\x1B\x61\x01\x1B\x21\x00' + (EncabezadoTicket || 'SIZE SOFT X') + '\n'));
            parts.push(textEncoder.encode('\x1B\x32'));
            parts.push(textEncoder.encode('\x1B\x61\x00\x1B\x21\x00' + linea + '\n'));

            const logoBase64 = parametrosCajaForm?.logo;
            let logoBlob = null;
            if (logoBase64) {
                try {
                    const binary = atob(logoBase64);
                    const bytes = new Uint8Array(binary.length);
                    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
                    logoBlob = new Blob([bytes], { type: "image/png" });
                } catch (err) {
                    console.warn("Logo no disponible:", err);
                }
            }

            parts.push(textEncoder.encode('\x1B\x61\x00'));
            parts.push(encodeTicketDatoClave(textEncoder, 'Folio Apartado: ' + (iFolioApartado || "") + '\n'));
            parts.push(textEncoder.encode('Partida: ' + (iIDPartida || "") + '\n'));
            parts.push(encodeTicketDatoClave(textEncoder, 'Fecha: ' + (dteFechaRegistro ? new Date(dteFechaRegistro).toLocaleString() : new Date().toLocaleString()) + '\n'));
            parts.push(encodeTicketDatoClave(textEncoder, 'Cliente: ' + (sNombreCliente || 'N/D') + '\n'));
            parts.push(textEncoder.encode(linea + '\n'));

            parts.push(textEncoder.encode('\x1B\x45\x01' + (sDescripcionArticulo || "Sin descripcion") + '\x1B\x45\x00' + '\n'));
            parts.push(textEncoder.encode('Clave: ' + (sClaveArticulo || "") + '  Talla: ' + (dMedida || 0) + '\n'));
            parts.push(textEncoder.encode('Cantidad: ' + (dCantidadArticulo || 0) + '  Importe: ' + NumberFormat$(dCostoArticulo) + '\n'));
            parts.push(textEncoder.encode(linea + '\n'));

            parts.push(textEncoder.encode('Total Abonado: ' + NumberFormat$(dTotalAbonado || 0) + '\n'));
            parts.push(textEncoder.encode('Total Articulo: ' + NumberFormat$(dCostoArticulo || 0) + '\n'));

            if (sMontoEnLetra) {
                parts.push(textEncoder.encode('Son: ' + sMontoEnLetra + '\n'));
            }

            parts.push(textEncoder.encode(linea + '\n'));
            parts.push(textEncoder.encode('\x1B\x21\x30' + 'ENTREGA COMPLETA' + '\x1B\x21\x00' + '\n'));
            parts.push(textEncoder.encode(linea + '\n'));

            parts.push(textEncoder.encode('__________________________\n'));
            parts.push(textEncoder.encode('   FIRMA DEL CLIENTE\n'));
            parts.push(textEncoder.encode('   (Nombre y fecha)\n'));
            parts.push(textEncoder.encode('\n'));
            parts.push(textEncoder.encode('Recibí de conformidad la mercancía\n'));
            parts.push(textEncoder.encode('descrita arriba en buen estado\n'));
            parts.push(textEncoder.encode('y acepto las condiciones de cambios\n'));
            parts.push(textEncoder.encode('en plazos no mayores a 15 días.\n'));
            parts.push(textEncoder.encode(linea + '\n'));

            parts.push(textEncoder.encode('\x1B\x61\x01\x1B\x45\x01' + 'POLÍTICA DE CAMBIOS (15 DÍAS)\n' + '\x1B\x45\x00'));
            parts.push(textEncoder.encode('\x1B\x61\x00' + 'Artículo sin uso, con etiquetas\ny empaque original.\n'));
            parts.push(textEncoder.encode('No aplica en ofertas.\n'));
            parts.push(textEncoder.encode('\x1B\x45\x01' + 'NO SE ACEPTAN DEVOLUCIONES.\n' + '\x1B\x45\x00\n'));
            parts.push(textEncoder.encode('\x1B\x61\x00' + linea + '\n'));

            parts.push(textEncoder.encode('\x1B\x61\x01' + 'Gracias por su preferencia!\n\n\n\n\n'));
            parts.push(textEncoder.encode('\x1D\x56\x00'));

            const totalLength = parts.reduce((sum, part) => sum + part.length, 0);
            const ticketData = new Uint8Array(totalLength);
            let offset = 0;
            parts.forEach(part => {
                ticketData.set(part, offset);
                offset += part.length;
            });

            const printerName = parametrosCajaForm.nombreimpresoraapartados?.trim() || "";
            const ticketFormData = new FormData();
            ticketFormData.append("ticket", new Blob([ticketData], { type: "application/octet-stream" }));
            ticketFormData.append("printerName", printerName);
            if (logoBlob) {
                ticketFormData.append("logo", logoBlob, "logocliente.png");
            }

            const response = await fetch(`http://localhost:4000/api/imprimirticket`, {
                method: "POST",
                body: ticketFormData,
            });

            if (!response.ok) {
                handleOpenAlert(`Error al imprimir acuse de entrega: ${response.statusText}`,"error");
                return false;
            }

            handleOpenAlert("Acuse de entrega impreso correctamente", "OK");
            return true;
        } catch (error) {
            handleOpenAlert(`Error al imprimir acuse de entrega: ${getErrorMessage(error)}`, "error");
            return false;
        }
    };

    const handleImprimirTicketCorte = async (data) => {
        if (!data) return;

        const caja = data[0]?.pc || data[0]?.sPC || "";

        let montoApertura = 0;
        let fechaApertura = "";

        if (caja) {
            try {
                const urlStatusCaja = apiStatusCaja.replace("{caja}", caja);
                const responseStatus = await GetRequest({ url: urlStatusCaja });
                if (!responseStatus.hasError && responseStatus.result) {
                    montoApertura = responseStatus.result.montoinicialapertura || responseStatus.result.dMontoInicialApertura || 0;
                    fechaApertura = responseStatus.result.fechaultimaapertura || responseStatus.result.dteFechaUltimaApertura || "";
                }
            } catch (error) {
                handleOpenAlert("Error al obtener status de caja: " + getErrorMessage(error), "error");
            }
        }

        const formData = new FormData();
        const textEncoder = new TextEncoder();

        let ticketParts = [textEncoder.encode('\x1B\x40')];

        ticketParts.push(
            textEncoder.encode('\x1B\x61\x01\x1B\x21\x11' + 'CORTE DE CAJA\n'),
            textEncoder.encode('\x1B\x61\x00\x1B\x21\x00' + '-'.repeat(32) + '\n'),
            textEncoder.encode('Caja: ' + caja + '\n'),
            textEncoder.encode('Vendedor: ' + ((data[0]?.vendedor || data[0]?.sUsuario || "")) + '\n'),
            textEncoder.encode('Fecha corte: ' + ((data[0]?.fechacorte || data[0]?.dteFechaCorte || "")) + '\n'),
            textEncoder.encode('-'.repeat(32) + '\n')
        );

        if (montoApertura > 0) {
            ticketParts.push(
                textEncoder.encode('Monto apertura: ' + montoApertura.toFixed(2) + '\n'),
                textEncoder.encode('Fecha apertura: ' + fechaApertura + '\n'),
                textEncoder.encode('-'.repeat(32) + '\n')
            );
        }

        ticketParts.push(
            textEncoder.encode('Efectivo recibido: ' + ((data[0]?.totalefectivo || 0)).toFixed(2) + '\n'),
            textEncoder.encode('Abono inicial credito: ' + ((data[0]?.totalefectivocredito || 0)).toFixed(2) + '\n'),
            textEncoder.encode('Total T. debito: ' + ((data[0]?.totaltarjetadebito || data[0]?.totaltdebito || 0)).toFixed(2) + '\n'),
            textEncoder.encode('Total T. credito: ' + ((data[0]?.totaltarjetacredito || data[0]?.totaltcredito || 0)).toFixed(2) + '\n'),
            textEncoder.encode('Total transferencias: ' + ((data[0]?.totaltransferencia || 0)).toFixed(2) + '\n'),
            textEncoder.encode('Total credito cliente: ' + ((data[0]?.totalcreditocliente || 0)).toFixed(2) + '\n'),
            textEncoder.encode('Total abonos apartados: ' + ((data[0]?.totalabonosapartados || 0)).toFixed(2) + '\n'),
            textEncoder.encode('Total devoluciones: ' + ((data[0]?.totaldevoluciones || 0)).toFixed(2) + '\n'),
            textEncoder.encode('Total retiros: ' + ((data[0]?.totalretiros || 0)).toFixed(2) + '\n'),
            textEncoder.encode('-'.repeat(32) + '\n'),
            textEncoder.encode('Total general: ' + ((data[0]?.totalgeneral || 0)).toFixed(2) + '\n'),
            textEncoder.encode('-'.repeat(32) + '\n'),
            textEncoder.encode('\x1B\x61\x01' + 'Formato estandarizado SizeSoftX!\n'),
            textEncoder.encode('\n\n\n\n\n\n\n\x1D\x56\x00')
        );

        const totalLength = ticketParts.reduce((sum, part) => sum + part.length, 0);
        const finalTicket = new Uint8Array(totalLength);
        let offset = 0;
        ticketParts.forEach(part => {
            finalTicket.set(part, offset);
            offset += part.length;
        });

        formData.append("ticket", new Blob([finalTicket], { type: "application/octet-stream" }));
        formData.append("printerName", parametrosCajaForm.nombreimpresoraventas.trim());

        const logoBase64 = parametrosCajaForm?.logo;
        if (logoBase64) {
            try {
                const binary = atob(logoBase64);
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
                formData.append("logo", new Blob([bytes], { type: "image/png" }), "logocliente.png");
            } catch (err) {
                handleOpenAlert("Logo no disponible: " + getErrorMessage(err), "error");
            }
        }

        try {
            const response2 = await fetch(`http://localhost:4000/api/imprimirticket`, {
                method: "POST",
                body: formData,
            });

            if (!response2.ok) {
                handleOpenAlert(`Error en envío de impresión de corte: ${response2.statusText}`);
                return;
            }

            handleOpenAlert("Impresión realizada", "OK");
        } catch (error) {
            handleOpenAlert(`Error en impresión de corte: ${getErrorMessage(error)}`, "error");
        }
    };

    const handleFirmarVenta = async (e) => {
        let nombreUsuario = e.target.Usuario;
        let foliopreventa = e.target.foliopreventa;
        let caja = e.target.caja;

        if (nombreUsuario === null || nombreUsuario === undefined || foliopreventa === 0 || foliopreventa === undefined || caja === null || caja === undefined)

            var url = apiFirmatPreventa.replace("{foliopreventa}", foliopreventa);
        url = url.replace("{usuariopreventa}", nombreUsuario);
        url = url.replace("{caja}", caja);

        var response = await GetPost({
            url,
            loader: "Firmando preventa"
        });

        if (!response.ok) {
            handleOpenAlert(`Error en firma de preventra: ${response.statusText}`);
            return;
        }

        handleOpenAlert('Preventa firmada correctamente:', "success");

        await handleInicializarVentanaPreVentas();
        const data = await handleObtenerVentas(parametrosCajaForm.tipoventa, parametrosCajaForm.tipoventa === "VENTA" ? parametrosCajaForm.folioventa : parametrosCajaForm.foliopreventa, parametrosCajaForm.caja);
        await handleRetotalizarCuentaVenta(data ?? []);
    };

    const handleCambioTipoVenta = async (tipoVenta) => {
        await setParametrosCajaForm({
            ...parametrosCajaForm,
            tipoventa: tipoVenta,
        });
    };

    const handleArirModalFirmaPreVenta = () => {
        setStatusKeyActions(true);
        setOpenModalFirma(true);
    };

    const handleCerrarModalFirmaPreVenta = () => {
        setStatusKeyActions(false);
        setOpenModalFirma(false);
    };

    const handleFirmarPreventa = async (folioPreventa, vendedorPreventa) => {
        if (!folioPreventa || !vendedorPreventa)
            return;

        if (listaPreventaTemporal.length === 0) {
            handleOpenAlert("No hay registros para firmar")
            return;
        }

        setStatusWaiting(true);
        const response = await PostRequest({
            url: apiFirmarPreventa,
            body: {
                foliopreventa: folioPreventa,
                vendedorpreventa: vendedorPreventa,
                caja: parametrosCajaForm.caja
            },
            loader: "Firmando preventa..."
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
        }

        await handleInicializarVentanaPreVentas();
        handleOpenAlert(`Firma de preventra aplicada`, "success");
    };

    const handleAbrirModalJalarPreVentaCotizacion = (modo) => {
        setStatusKeyActions(true);
        setOpenModalJalarPreventaCotizacion(true);
    };

    const handleCerrarModalJalarPreVentaCotizacion = () => {
        setStatusKeyActions(false);
        setOpenModalJalarPreventaCotizacion(false);
    };

    const handleInyectarPreventaCotizacionAVenta = async (e) => {

        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        if (!e.tipoventa)
            return;

        let url = "";

        if (e.tipoventa === "PREVENTA") {
            url = apiInyectarPreventaAVenta.replace("{remision}", parametrosCajaForm.folioventa);
            url = url.replace("{pc}", parametrosCajaForm.caja.trim());
            url = url.replace("{foliopreventa}", e.foliopreventa);
            url = url.replace("{vendedorpreventa}", e.vendedorpreventa);
        }

        if (e.tipoventa === "COTIZACIÓN") {
            url = apiInyectarCotizacionAVenta.replace("{remision}", parametrosCajaForm.folioventa);
            url = url.replace("{pc}", parametrosCajaForm.caja.trim());
            url = url.replace("{remisioncotizacion}", e.remision);
            url = url.replace("{vendedorcotizacion}", e.vendedorpreventa);
        }

        setStatusWaiting(true);
        const response = await GetRequest({
            url: url,
            loader: "Obteniendo remisión de venta en caja"
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        handleOpenAlert("Operación exitosa", "success");
        handleCerrarModalJalarPreVentaCotizacion();
        handleClickRefrescarDatosVenta();
        setStatusKeyActions(false);
    };

    const handleRecuperarPreventas = async (vendedor, partidaData) => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        if (!partidaData || partidaData.foliopreventa === 0 || partidaData.foliopreventa === undefined)
            return;

        if (!vendedor)
            return;

        const pcDestino = parametrosCajaForm.caja.trim();
        const pcOrigen = (partidaData.pc || pcDestino).trim();
        let folioPreventa = partidaData.foliopreventa;

        if (pcOrigen.toUpperCase() !== pcDestino.toUpperCase()) {
            const urlTransferirPreventa = apiTransferirPreventaCaja
                .replace("{vendedor}", encodeURIComponent(vendedor))
                .replace("{pcOrigen}", encodeURIComponent(pcOrigen))
                .replace("{folioPreventa}", folioPreventa)
                .replace("{pcDestino}", encodeURIComponent(pcDestino));

            const responseTransferencia = await GetRequest({
                url: urlTransferirPreventa,
                loader: "Recuperando preventa en esta caja...",
            });

            if (responseTransferencia.hasError) {
                handleOpenAlert(responseTransferencia.message);
                return;
            }

            folioPreventa = responseTransferencia.result;
        }

        setParametrosCajaForm({
            ...parametrosCajaForm,
            foliopreventa: folioPreventa,
        })

        const data = await handleObtenerVentas("PREVENTA", folioPreventa, pcDestino);
        await handleRetotalizarCuentaVenta(data ?? []);
    };

    const handleAbrirModalRecuperarPreVenta = () => {
        setStatusKeyActions(true);
        setOpenModalRecuperarPreventa(true);
    };

    const handleCerrarModalRecuperarPreVenta = () => {
        setStatusKeyActions(false);
        setOpenModalRecuperarPreventa(false);
    };

    const handleAbrirModalRecuperarPreVentaFirma = (e) => {

        setStatusKeyActions(true);
        setOpenModalRecuperarPreventaFirma(true);
    };

    const handleCerrarModalRecuperarPreVentaFirma = () => {
        setStatusKeyActions(false);
        setOpenModalRecuperarPreventaFirma(false);
    };

    const handleAbrirModalGenerarApartado = (e) => {
        setStatusKeyActions(true);
        setOpenModalGenerarApartado(true);
    };

    const handleCerrarModalGenerarApartado = () => {
        setStatusKeyActions(false);
        setOpenModalGenerarApartado(false);
    };

    const handleAbrirCobrarApartado = (e) => {
        setOpenCobrarApartado(true);
    };

    const handleCerrarCobrarApartado = () => {
        setOpenCobrarApartado(false);
    };

    const handleGenerarApartadoSubmit = async (detalles, listData) => {
        if (!listData || listData.length === 0) {
            console.warn("Aviso: listData vacío");
            return;
        }

        if (!detalles || Object.keys(detalles).length === 0) {
            console.warn("Aviso: detalles vacío");
            return;
        }

        const data = listData.map(r => ({
            almacenexhibidor: (r.almacenexhibidor || "").trim(),
            remision: r.remision,
            caja: (r.pc || "").trim(),
            usuario: usuarioData.Usuario,
            idpartida: r.idpartida,
            clavearticulo: (r.clavearticulo || "").trim(),
            descripcion: (r.descripcion || "").trim(),
            medida: r.medida,
            cantidad: r.cantidad,
            costounitario: r.costounitario,
            costocliente: r.costocliente || r.costounitario,
            descuento: r.descuento,
            montoabono: parseFloat(r.montoAbono || 0),
            nombrecliente: (detalles.nombrecliente || "").trim(),
            concepto: (detalles.concepto || "").trim(),
            grupo: (detalles.grupo || "").trim(),
            foliopreventa: r.foliopreventa || 0,
            vendedorpreventa: (r.vendedorpreventa || "").trim(),
            telefonocontacto: detalles.telefonocliente || "",
        }));

        setStatusWaiting(true);

        let response;

        try {
            response = await PostRequest({
                url: apiRegistrarApartadoList,
                body: data,
                loader: "Se está registrando el apartado..."
            });
            setStatusWaiting(false);
        } catch (err) {
            handleOpenAlert("Error al registrar apartado: " + getErrorMessage(err), "error");
            setStatusWaiting(false);
            return;
        }

        if (response.hasError) {
            handleOpenAlert(response.message);
            setStatusWaiting(false);
            return;
        }

        try {
            const cabecerox = response?.result?.cabecero;
            const detallesx = response?.result?.detallesabonos;

            if (!cabecerox) {
                handleOpenAlert("Error: No se recibio data del cabecero del apartado");
                return;
            }
            if (!detallesx) {
                handleOpenAlert("Error: No se recibio data de detalles del apartado");
                return;
            }

            await handleImprimirTicketApartados(cabecerox, detallesx);

            const apiUrlEliminar = apiEliminarVenta
                .replace("{remision}", parametrosCajaForm.folioventa)
                .replace("{tipoventa}", "VENTA")
                .replace("{pc}", parametrosCajaForm.caja.trim());
            await GetRequest({ url: apiUrlEliminar });

            const preventasPortatiles = listData
                .map(r => ({
                    vendedorpreventa: (r.vendedorpreventa || "").trim(),
                    foliopreventa: r.foliopreventa || 0,
                }))
                .filter(p => p.vendedorpreventa && p.foliopreventa)
                .filter((item, index, self) =>
                    index === self.findIndex(t => t.vendedorpreventa === item.vendedorpreventa && t.foliopreventa === item.foliopreventa)
                );

            if (preventasPortatiles.length > 0) {
                await PostRequest({
                    url: apiLimpiarPreventasPortatil,
                    body: preventasPortatiles,
                    loader: "Limpiando preventas portátiles..."
                });
            }

            setStatusWaiting(false);
            setListaRemisionTemporal([]);
            await handleInicializarVentanaVentas();

            handleOpenAlert("Operación de apartado correcta", "success");
            setOpenModalGenerarApartado(false);
            setStatusKeyActions(false);

        }
        catch (error) {
            setStatusWaiting(false);
            handleOpenAlert("Error en procesos de finalización de apartado: " + getErrorMessage(error), "error");
        }
    };

    const generarApartadoRef = useRef(false);

    const round2Apartado = (v) => Math.round((Number(v) || 0) * 100) / 100;

    const handleGenerarApartadoConPagos = async (detalles, filasConAbono, pago) => {
        if (generarApartadoRef.current) return { ok: false };
        generarApartadoRef.current = true;
        setStatusWaiting(true);

        try {
            if (!filasConAbono || filasConAbono.length === 0) {
                handleOpenAlert("No hay partidas en la venta para apartar", "warning");
                return { ok: false };
            }

            const nombre = (detalles?.nombrecliente || "").trim();
            const concepto = (detalles?.concepto || "").trim();
            const grupo = (detalles?.grupo || "").trim();
            if (!concepto) {
                handleOpenAlert("Debe seleccionar o ingresar un concepto de apartado", "warning");
                return { ok: false };
            }
            if (!nombre) {
                handleOpenAlert("Debe ingresar el nombre del cliente", "warning");
                return { ok: false };
            }

            const caja = (parametrosCajaForm.caja || "").trim();
            if (!caja || caja === "CAJA-DEFAULT") {
                handleOpenAlert("Caja no configurada. No se puede generar el apartado.", "warning");
                return { ok: false };
            }

            const tipoPago = (pago?.tipoPago || "EFECTIVO").trim() || "EFECTIVO";
            const montoEfectivo = round2Apartado(pago?.montoEfectivo);
            const montoTipoPago = round2Apartado(pago?.montoTipoPago);
            const serial = (pago?.serial || "").trim();
            const totalPagos = round2Apartado(montoEfectivo + montoTipoPago);
            const sumaColumna = round2Apartado(filasConAbono.reduce((acc, r) => acc + (Number(r.montoAbono) || 0), 0));

            if (Math.abs(sumaColumna - totalPagos) > 0.01) {
                handleOpenAlert(`La columna de abonos (${sumaColumna}) no cuadra con el capital recibido (${totalPagos})`, "warning");
                return { ok: false };
            }

            // Este modal no hace entrega definitiva: solo primer abono parcial
            // o apartado sin abonos. La liquidación total es en FrmApartados.
            const totalCuenta = round2Apartado(filasConAbono.reduce((acc, r) => acc + (Number(r.total) || ((Number(r.cantidad) || 0) * (Number(r.costocliente ?? r.costounitario) || 0))), 0));
            if (totalCuenta > 0 && sumaColumna > 0 && (totalCuenta - sumaColumna) <= 0.01) {
                handleOpenAlert("El anticipo no puede cubrir el 100% de la cuenta. Solo se recibe primer abono parcial o apartado sin abonos; la liquidación total se hace en el módulo de Apartados.", "warning");
                return { ok: false };
            }

            for (const r of filasConAbono) {
                const abono = round2Apartado(r.montoAbono);
                const totalPartida = round2Apartado(Number(r.total) || ((Number(r.cantidad) || 0) * (Number(r.costocliente ?? r.costounitario) || 0)));
                if (abono < 0 || abono > totalPartida + 0.01) {
                    handleOpenAlert(`El abono de "${r.descripcion || ""}" supera el total de su partida`, "warning");
                    return { ok: false };
                }
            }

            // ---------- Fase A: crear apartado con anticipo 0 ----------
            const data = filasConAbono.map(r => ({
                almacenexhibidor: (r.almacenexhibidor || "").trim(),
                remision: r.remision,
                caja: (r.pc || "").trim(),
                usuario: usuarioData.Usuario,
                idpartida: r.idpartida,
                clavearticulo: (r.clavearticulo || "").trim(),
                descripcion: (r.descripcion || "").trim(),
                medida: r.medida,
                cantidad: r.cantidad,
                costounitario: r.costounitario,
                costocliente: r.costocliente || r.costounitario,
                descuento: r.descuento,
                montoabono: 0,
                nombrecliente: nombre,
                concepto: concepto,
                grupo: grupo,
                foliopreventa: r.foliopreventa || 0,
                vendedorpreventa: (r.vendedorpreventa || "").trim(),
                telefonocontacto: (detalles.telefonocliente || ""),
            }));

            const response = await PostRequest({
                url: apiRegistrarApartadoList,
                body: data,
                loader: "Se está registrando el apartado..."
            });

            if (response.hasError) {
                handleOpenAlert(response.message);
                return { ok: false };
            }

            const cabecerox = response?.result?.cabecero;
            const detallesx = response?.result?.detallesabonos;

            if (!cabecerox) {
                handleOpenAlert("Error: No se recibio data del cabecero del apartado");
                return { ok: false };
            }
            if (!detallesx) {
                handleOpenAlert("Error: No se recibio data de detalles del apartado");
                return { ok: false };
            }

            const folioApartado = cabecerox.folioapartado;
            // Las partidas creadas corresponden en orden a las enviadas.
            const creadas = filasConAbono.map((r, idx) => ({
                ...r,
                montoAbono: round2Apartado(r.montoAbono),
                idpartidaReal: detallesx[idx]?.idpartida ?? r.idpartida,
                folioReal: detallesx[idx]?.folioapartado ?? folioApartado,
            })).filter(r => r.montoAbono > 0);

            // ---------- Fase B: un solo abono por partida con su tipopago ----------
            // Si hay monto en tipo de pago se registra bajo ese tipo (con su
            // serial); si todo es efectivo, bajo EFECTIVO. Así cada renglón
            // genera exactamente un registro en AbonosApartados.
            const usarTipoPago = montoTipoPago > 0;
            const tipoRegistro = usarTipoPago ? tipoPago : "EFECTIVO";
            const serialRegistro = usarTipoPago ? serial : "";
            const registrados = [];
            for (let i = 0; i < creadas.length; i++) {
                const row = creadas[i];
                const respAbono = await PostRequest({
                    url: apiRegistrarAbonoApartado,
                    body: {
                        idpartida: row.idpartidaReal,
                        folioapartado: row.folioReal,
                        montoabono: row.montoAbono,
                        tipopago: tipoRegistro,
                        serialtarjetachequevale: serialRegistro,
                        caja: caja,
                    },
                    loader: "Registrando abono de apartado..."
                });
                if (respAbono.hasError || respAbono.result === false) {
                    handleOpenAlert(respAbono.hasError ? respAbono.message : "No se realizó la operación de abono por apartado en sistema");
                    return { ok: false, parcial: true, folioapartado: folioApartado };
                }
                registrados.push({ ...respAbono.result, __row: row, __tipo: tipoRegistro, __serial: serialRegistro });
            }

            const sumaRegistrada = round2Apartado(registrados.reduce((acc, a) => acc + (Number(a.montoabono ?? a.dMontoAbono) || 0), 0));
            if (Math.abs(sumaRegistrada - sumaColumna) > 0.01) {
                handleOpenAlert(`Los abonos registrados (${sumaRegistrada}) no coinciden con lo capturado (${sumaColumna}). Revise el folio ${folioApartado} en el módulo de Apartados.`, "error");
                return { ok: false, parcial: true, folioapartado: folioApartado };
            }

            // ---------- Verificación contra estado de cuenta ----------
            try {
                const primera = creadas.length > 0 ? creadas[0] : null;
                if (primera) {
                    let urlEC = apiBuscarEstadoCuenteClienteApartados.replace("{nombrecliente}", encodeURIComponent(nombre));
                    urlEC = urlEC.replace("{folioapartado}", primera.folioReal);
                    urlEC = urlEC.replace("{partida}", primera.idpartidaReal);
                    const respEC = await GetRequest({ url: urlEC });
                    if (!respEC.hasError && respEC.result) {
                        const totalEC = round2Apartado(Number(respEC.result?.totalabonado) || 0);
                        if (Math.abs(totalEC - sumaRegistrada) > 0.01) {
                            handleOpenAlert(`Aviso: el estado de cuenta del folio ${folioApartado} muestra ${totalEC} y lo registrado suma ${sumaRegistrada}. Verifíquelo en el módulo de Apartados.`, "warning");
                        }
                    }
                }
            } catch {
                // La verificación no bloquea: ya se validó contra las respuestas.
            }

            // ---------- Tickets: apartado + recibos por abono ----------
            try {
                const detallesTicket = detallesx.map((d, idx) => ({
                    ...d,
                    montoabonado: round2Apartado(filasConAbono[idx]?.montoAbono || 0),
                    vendedorpreventa: d.vendedorpreventa || (filasConAbono[idx]?.vendedorpreventa || ""),
                    almacenexhibidor: d.almacenexhibidor || (filasConAbono[idx]?.almacenexhibidor || ""),
                }));
                await handleImprimirTicketApartados(cabecerox, detallesTicket);
            } catch (error) {
                handleOpenAlert("El apartado fue registrado, pero no se imprimió el ticket de apartado: " + getErrorMessage(error), "error");
            }

            // const abonadoPorPartida = {};
            // for (const reg of registrados) {
            //     try {
            //         const row = reg.__row;
            //         const monto = Number(reg.montoabono ?? reg.dMontoAbono) || 0;
            //         abonadoPorPartida[row.idpartidaReal] = round2Apartado((abonadoPorPartida[row.idpartidaReal] || 0) + monto);
            //         const letra = await MontoEnLetra(monto);
            //         // await handleImprimirTicketAbono({
            //         //     ...reg,
            //         //     sNombreCliente: nombre,
            //         //     sClaveArticulo: row.clavearticulo || "",
            //         //     sDescripcionArticulo: row.descripcion || "",
            //         //     dMedida: row.medida || 0,
            //         //     dCantidadArticulo: row.cantidad || 0,
            //         //     dCostoArticulo: row.costocliente || row.costounitario || 0,
            //         //     dMontoDescuentoArticulo: 0,
            //         //     dTotalAbonado: abonadoPorPartida[row.idpartidaReal],
            //         //     sMontoEnLetra: letra || "",
            //         //     EncabezadoTicket: reg.encabezado || parametrosCajaForm.encabezadoticket || "",
            //         //     PieDeTicket: reg.pie || ""
            //         // });
            //     } catch (error) {
            //         handleOpenAlert("Abono registrado, pero no se imprimió su recibo. Puede reimprimirlo desde el módulo de Apartados.", "error");
            //     }
            // }

            // ---------- Limpieza igual que el flujo anterior ----------
            const apiUrlEliminar = apiEliminarVenta
                .replace("{remision}", parametrosCajaForm.folioventa)
                .replace("{tipoventa}", "VENTA")
                .replace("{pc}", parametrosCajaForm.caja.trim());
            await GetRequest({ url: apiUrlEliminar });

            const preventasPortatiles = filasConAbono
                .map(r => ({
                    vendedorpreventa: (r.vendedorpreventa || "").trim(),
                    foliopreventa: r.foliopreventa || 0,
                }))
                .filter(p => p.vendedorpreventa && p.foliopreventa)
                .filter((item, index, self) =>
                    index === self.findIndex(t => t.vendedorpreventa === item.vendedorpreventa && t.foliopreventa === item.foliopreventa)
                );

            if (preventasPortatiles.length > 0) {
                await PostRequest({
                    url: apiLimpiarPreventasPortatil,
                    body: preventasPortatiles,
                    loader: "Limpiando preventas portátiles..."
                });
            }

            setListaRemisionTemporal([]);
            await handleInicializarVentanaVentas();

            handleOpenAlert(`Operación de apartado correcta. Folio ${folioApartado}`, "success");
            return { ok: true, folioapartado: folioApartado };
        }
        catch (error) {
            handleOpenAlert("Error en proceso de apartado: " + getErrorMessage(error), "error");
            return { ok: false };
        }
        finally {
            setStatusWaiting(false);
            generarApartadoRef.current = false;
        }
    };

    const handleAbrirModalGenerarAbonoApartados = () => {
        entregaDefinitivaApartadoRef.current = false;
        setIsModoEntregaDefinitiva(false);
        setOpenModalCobrarAbonoApartado(true);
    };

    const handleAbrirModalEntregaDefinitiva = async (montoRestante) => {
        const saldoRestante = parseFloat(montoRestante || 0);

        if (saldoRestante <= 0) {
            const apartado = dataEstadoCuentaApartado?.apartados?.[0] || rowPartidaApartadoFind || {};
            const dataEntrega = {
                folioapartado: apartado.folioapartado || rowPartidaApartadoFind?.folioapartado || ventaTotales.folioapartado || 0,
                idpartida: apartado.idpartida || rowPartidaApartadoFind?.idpartida || ventaTotales.idpartida || 0,
                clavearticulo: apartado.clavearticulo || rowPartidaApartadoFind?.clavearticulo || "",
                medida: apartado.medida || rowPartidaApartadoFind?.medida || 0,
                cantidadarticulo: apartado.cantidadarticulo || rowPartidaApartadoFind?.cantidadarticulo || 0,
                costoarticulo: apartado.costoarticulo || rowPartidaApartadoFind?.costoarticulo || 0,
                almacenexhibidor: apartado.almacenexhibidor || rowPartidaApartadoFind?.almacenexhibidor || "",
                caja: parametrosCajaForm.caja.trim()
            };

            const resultEntrega = await handleEntregaDefinitivaApartado(dataEntrega);
            if (resultEntrega) {
                let acuseImpreso = false;
                try {
                    acuseImpreso = await handleImprimirTicketAcuseEntrega(resultEntrega);
                } catch (error) {
                    handleOpenAlert(`Error al imprimir acuse: ${getErrorMessage(error)}`, "error");
                }
                if (!acuseImpreso) {
                    handleOpenAlert("La entrega definitiva fue registrada, pero no se imprimió el acuse. El apartado se marcará como terminado y puede reimprimirse el acuse.");
                }

                const apartadoTerminado = await handleTerminarApartado(dataEntrega);
                if (apartadoTerminado) {
                    handleOpenAlert("Apartado terminado correctamente", "success");
                }
            }
            return;
        }

        setVentaTotales({
            ...ventaTotales,
            totalapagar: saldoRestante,
            efectivo: saldoRestante,
            cambio: 0
        });

        entregaDefinitivaApartadoRef.current = true;
        setIsModoEntregaDefinitiva(true);
        setOpenModalCobrarAbonoApartado(true);
    };

    const handleCerrarModalGenerarAbonoApartados = () => {
        setOpenModalCobrarAbonoApartado(false);
        entregaDefinitivaApartadoRef.current = false;
        setIsModoEntregaDefinitiva(false);
    };

    const handClickCobrarAbonoApartado = async (datapago) => {
        
        if (cobrarAbonoRef.current) return;
        cobrarAbonoRef.current = true;

        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            cobrarAbonoRef.current = false;
            return;
        }

        try {
            const data = {
                idpartida: ventaTotales.idpartida,
                folioapartado: ventaTotales.folioapartado,
                montoabono: parseFloat(datapago.totaltipopago || 0) + parseFloat(datapago.totalefectivo || 0),
                tipopago: datapago.tipopago?.trim() || "",
                serialtarjetachequevale: datapago.serialtarjetachequevale?.trim() || "",
                caja: parametrosCajaForm.caja.trim(),
            };

            const response = await PostRequest({
                url: apiRegistrarAbonoApartado,
                body: data,
                loader: "Realizando registro de abono en apartado"
            });

            if (response.hasError) {
                handleOpenAlert(response.message);
                cobrarAbonoRef.current = false;
                return;
            }

            if (response.result === false) {
                handleOpenAlert("No se realizó la operación de abono por apartado en sistema");
                cobrarAbonoRef.current = false;
                return;
            }

            const abonoDataGenerado = response.result;
            setAbonoDataGenerado(abonoDataGenerado);
            const esEntregaDefinitiva = entregaDefinitivaApartadoRef.current || isModoEntregaDefinitiva;

            // Enriquecer datos del abono con información del contexto
            const abonoEnriquecido = {
                ...abonoDataGenerado,
                sNombreCliente: dataEstadoCuentaApartado?.nombrecliente || rowPartidaApartadoFind?.nombrecliente || "",
                sClaveArticulo: dataEstadoCuentaApartado?.apartados?.[0]?.clavearticulo || rowPartidaApartadoFind?.clavearticulo || "",
                sDescripcionArticulo: dataEstadoCuentaApartado?.apartados?.[0]?.descripcion || rowPartidaApartadoFind?.descripcion || "",
                dMedida: dataEstadoCuentaApartado?.apartados?.[0]?.medida || rowPartidaApartadoFind?.medida || 0,
                dCantidadArticulo: dataEstadoCuentaApartado?.apartados?.[0]?.cantidadarticulo || rowPartidaApartadoFind?.cantidadarticulo || 0,
                dCostoArticulo: dataEstadoCuentaApartado?.apartados?.[0]?.costoarticulo || rowPartidaApartadoFind?.costoarticulo || 0,
                dMontoDescuentoArticulo: dataEstadoCuentaApartado?.apartados?.[0]?.montodescuentoarticulo || rowPartidaApartadoFind?.montodescuentoarticulo || 0,
                dTotalAbonado: (dataEstadoCuentaApartado?.totalabonado || rowPartidaApartadoFind?.totalabonado || 0) + (abonoDataGenerado?.montoabono || abonoDataGenerado?.dMontoAbono || 0),
                sMontoEnLetra: ventaTotales?.montoEnLetra || "",
                EncabezadoTicket: abonoDataGenerado?.encabezado || parametrosCajaForm.encabezadoticket || "",
                PieDeTicket: abonoDataGenerado?.pie || ""
            };

            handleCerrarModalGenerarAbonoApartados();

            const montoAbonoActual = parseFloat(datapago.totaltipopago || 0) + parseFloat(datapago.totalefectivo || 0);
            const totalAbonadoPrevio = dataEstadoCuentaApartado?.totalabonado || rowPartidaApartadoFind?.totalabonado || 0;
            const costoArticuloTotal = dataEstadoCuentaApartado?.apartados?.[0]?.costoarticulo || rowPartidaApartadoFind?.costoarticulo || 0;
            const esPagoCompleto = costoArticuloTotal > 0 && (totalAbonadoPrevio + montoAbonoActual) >= costoArticuloTotal;

            let abonoImpreso = false;
            try {
                abonoImpreso = await handleImprimirTicketAbono(abonoEnriquecido);
            } catch (error) {
                handleOpenAlert(`Error al imprimir ticket: ${getErrorMessage(error)}`, "error");
            }
            if (!abonoImpreso) {
                handleOpenAlert("El abono fue registrado, pero no se imprimió el ticket de abono. Puede reimprimirlo desde otras acciones.");
            }

            if (esEntregaDefinitiva) {
                if (!esPagoCompleto) {
                    handleOpenAlert("El pago de entrega definitiva no cubre el total del apartado");
                    return;
                }

                const dataEntrega = {
                    folioapartado: ventaTotales.folioapartado,
                    idpartida: ventaTotales.idpartida,
                    clavearticulo: rowPartidaApartadoFind?.clavearticulo || "",
                    medida: rowPartidaApartadoFind?.medida || 0,
                    cantidadarticulo: rowPartidaApartadoFind?.cantidadarticulo || 0,
                    costoarticulo: rowPartidaApartadoFind?.costoarticulo || 0,
                    almacenexhibidor: rowPartidaApartadoFind?.almacenexhibidor || "",
                    caja: parametrosCajaForm.caja.trim()
                };

                const resultEntrega = await handleEntregaDefinitivaApartado(dataEntrega);
                if (resultEntrega) {
                    let acuseImpreso = false;
                    try {
                        acuseImpreso = await handleImprimirTicketAcuseEntrega(resultEntrega);
                    } catch (error) {
                        handleOpenAlert(`Error al imprimir acuse: ${getErrorMessage(error)}`, "error");
                    }
                    if (!acuseImpreso) {
                        handleOpenAlert("La entrega definitiva fue registrada, pero no se imprimió el acuse. El apartado se marcará como terminado y puede reimprimirse el acuse.");
                    }

                    const apartadoTerminado = await handleTerminarApartado(dataEntrega);

                    if (apartadoTerminado) {
                        handleOpenAlert("Apartado terminado correctamente", "success");
                    }
                }

                entregaDefinitivaApartadoRef.current = false;
                setIsModoEntregaDefinitiva(false);
            }
        }
        catch (error) {
            handleOpenAlert("Error en proceso de cobro de abono: " + getErrorMessage(error), "error");
        }
        finally {
            cobrarAbonoRef.current = false;
        }
    };

    const handleAbrirModalCambioCostoApartados = () => {
        setOpenModalCambioCostoApartado(true);
    };

    const handleCerrarModalCambioCostoApartados = () => {
        setOpenModalCambioCostoApartado(false);
    };

    const handleCambiarCostoArticuloApartado = async (dataentre) => {

        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            await handleObtenerParametrosCaja();
        }

        setStatusWaiting(true);
        const response = await PostRequest({
            url: apiCambiarCostoArticuloApartado,
            body: dataentre,
            loader: "Realizando cambio costo en apartado"
        });
        setStatusWaiting(false);


        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        handleCerrarModalCambioCostoApartados();
    };

    const handleAbrirModalCancelarApartados = () => {
        setOpenModalCancelarApartado(true);
    };

    const handleCerrarModalCancelarApartados = () => {
        setOpenModalCancelarApartado(false);
    };

    const handleCancelarApartadoSubmit = async (dataentre) => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        setStatusWaiting(true);
        const response = await PostRequest({
            url: apiCancelarApartado,
            body: dataentre,
            loader: "Realizando cambio costo en apartado"
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        handleCerrarModalCancelarApartados();
    };

    const handleEntregaDefinitivaApartado = async (dataEntrega) => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            console.warn("[Apartados][EntregaDefinitivaApi] Caja default, no se envia peticion", {
                caja: parametrosCajaForm.caja,
                dataEntrega
            });
            return null;
        }

        setStatusWaiting(true);
        let response = null;
        try {
            response = await PostRequest({
                url: apiEntregaDefinitivaApartado,
                body: dataEntrega,
                loader: "Registrando entrega definitiva del apartado"
            });
        } catch (error) {
            console.error("[Apartados][EntregaDefinitivaApi][Exception]", {
                url: apiEntregaDefinitivaApartado,
                payload: dataEntrega,
                error
            });
            setStatusWaiting(false);
            handleOpenAlert("Error al registrar entrega definitiva: " + getErrorMessage(error), "error");
            return null;
        }
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return null;
        }

        return response.result;
    };

    const handleTerminarApartado = async (dataTermino) => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            console.warn("[Apartados][TerminarApartado] Caja default, no se envia peticion", {
                caja: parametrosCajaForm.caja,
                dataTermino
            });
            return false;
        }

        setStatusWaiting(true);
        const response = await PostRequest({
            url: apiTerminarApartado,
            body: dataTermino,
            loader: "Terminando apartado"
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return false;
        }

        if (response.result === true) {
            const folioApartado = dataTermino?.folioapartado;
            const idPartida = dataTermino?.idpartida;
            const actualizarStatusEntregado = (apartado) => {
                const mismoFolio = Number(apartado?.folioapartado || 0) === Number(folioApartado || 0);
                const mismaPartida = Number(apartado?.idpartida || apartado?.partida || 0) === Number(idPartida || 0);
                return mismoFolio && mismaPartida
                    ? { ...apartado, status: "ENTREGADO", statusapartado: "ENTREGADO" }
                    : apartado;
            };

            setDataEstadoCuentaApartado((prev) => ({
                ...prev,
                apartados: Array.isArray(prev?.apartados)
                    ? prev.apartados.map(actualizarStatusEntregado)
                    : [],
            }));
            setDataApartados((prev) => Array.isArray(prev) ? prev.map(actualizarStatusEntregado) : []);
            setRowPartidaApartadoFind((prev) => actualizarStatusEntregado(prev || {}));
            setStatusActualApartado(false);
            setStatusCobroApartado(false);
            return true;
        }

        return false;
    };

    const handleMantenimientoCuentasApartados = async () => {
        setStatusWaiting(true);
        const response = await PostRequest({
            url: apiMantenimientoCuentasApartados,
            body: {},
            loader: "Ejecutando mantenimiento de cuentas"
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return null;
        }

        const result = response.result || {};
        const detalles = Array.isArray(result.detalles) && result.detalles.length > 0
            ? `\n${result.detalles.slice(0, 5).join("\n")}`
            : "";

        handleOpenAlert(
            `${response.message || "Mantenimiento aplicado"}${detalles}`,
            result.errores > 0 ? "warning" : "OK"
        );
        handleRefreshApartadosData();
        return result;
    };

    const handleRefreshApartadosData = () => {
        setDataApartados([]);
        setDataEstadoCuentaApartado({
            nombrecliente: "",
            apartados: [],
            abonos: [],
            totalabonado: 0,
        });
    };

    const handleObtenerAlmacenesExhibidores = async () => {
        if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
            return;
        }

        setStatusWaiting(true);
        const response = await GetRequest({
            url: apiListaAlmacenesExhibidores,
            loader: "Obteniendo lisa de almacenes o exhibidores"
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            setListaAlmacenesExhibidores([]);
            return;
        }

        setListaAlmacenesExhibidores(response?.result || []);
    };

    const handleCerrarModalImpresion = () => {
        setStatusKeyActions(false);
        setOpenModalImpresion(false);
    };

    const handleAbrirModalImpresion = () => {
        setStatusKeyActions(true);
        setOpenModalImpresion(true);
    };

    const handleClickEstadoCuentaCliente = async () => {
        if (!dataEstadoCuentaApartado.apartados || dataEstadoCuentaApartado.apartados.length === 0 || !rowPartidaApartadoFind.folioapartado) {
            handleOpenAlert("No hay datos del apartado para imprimir. Seleccione un apartado primero.");
            return;
        }

        try {
            const formData = new FormData();
            const textEncoder = new TextEncoder();

            const apartado = dataEstadoCuentaApartado.apartados[0];

            let totalAbonado = 0;
            if (dataEstadoCuentaApartado.abonos && dataEstadoCuentaApartado.abonos.length > 0) {
                for (const abono of dataEstadoCuentaApartado.abonos) {
                    totalAbonado += (abono.montoabono || 0);
                }
            }

            const totalArticulo = (apartado.cantidadarticulo || 0) * (apartado.costoarticulo || 0);
            const restante = totalArticulo - totalAbonado;

            let ticketParts = [textEncoder.encode('\x1B\x40')];

            const encabezado = (parametrosCajaForm.encabezadoticket || "").trim();
            if (encabezado.length > 0) {
                ticketParts.push(textEncoder.encode('\x1B\x61\x01' + encabezado + '\n'));
                ticketParts.push(textEncoder.encode('\x1B\x61\x00\x1B\x21\x00' + '-'.repeat(32) + '\n'));
            }

            ticketParts.push(
                textEncoder.encode('\x1B\x61\x01\x1B\x21\x11' + 'ESTADO DE CUENTA\n'),
                textEncoder.encode('\x1B\x61\x00\x1B\x21\x00' + '-'.repeat(32) + '\n'),
                textEncoder.encode('Caja: ' + (parametrosCajaForm.caja || "") + '\n'),
                encodeTicketDatoClave(textEncoder, 'Folio Apartado: ' + (apartado.folioapartado || "") + '\n'),
                encodeTicketDatoClave(textEncoder, 'Fecha: ' + getDateString(apartado.fecharegistro) + '\n'),
                encodeTicketDatoClave(textEncoder, 'Cliente: ' + (dataEstadoCuentaApartado.nombrecliente || "No especificado") + '\n'),
                textEncoder.encode('-'.repeat(32) + '\n')
            );

            ticketParts.push(
                textEncoder.encode('Articulo:\n'),
                textEncoder.encode('Clave: ' + (apartado.clavearticulo || "") + '\n'),
                textEncoder.encode('Descripción: ' + (apartado.descripcion || "") + '\n'),
                textEncoder.encode('Medida: ' + (apartado.medida || "") + '\n'),
                textEncoder.encode('Cantidad: ' + (apartado.cantidadarticulo || 0) + '\n'),
                textEncoder.encode('Costo Unit.: $' + (apartado.costoarticulo || 0).toFixed(2) + '\n'),
                textEncoder.encode('Total: $' + totalArticulo.toFixed(2) + '\n'),
                textEncoder.encode('Status: ' + (apartado.status || "") + '\n'),
                textEncoder.encode('-'.repeat(32) + '\n')
            );

            ticketParts.push(
                textEncoder.encode('\x1B\x61\x01\x1B\x21\x11' + 'HISTORIAL DE ABONOS\n'),
                textEncoder.encode('\x1B\x61\x00\x1B\x21\x00' + '-'.repeat(32) + '\n')
            );

            if (dataEstadoCuentaApartado.abonos && dataEstadoCuentaApartado.abonos.length > 0) {
                for (const abono of dataEstadoCuentaApartado.abonos) {
                    ticketParts.push(
                        textEncoder.encode('Fecha: ' + getDateString(abono.fecharegistro) + '\n'),
                        textEncoder.encode('Abono #' + (abono.abono || "") + ': $' + (abono.montoabono || 0).toFixed(2) + '\n'),
                        textEncoder.encode('-'.repeat(15) + '\n')
                    );
                }
            } else {
                ticketParts.push(textEncoder.encode('Sin abonos realizados\n'));
            }

            ticketParts.push(
                textEncoder.encode('-'.repeat(32) + '\n'),
                textEncoder.encode('Total articulo: $' + totalArticulo.toFixed(2) + '\n'),
                textEncoder.encode('Total abonado: $' + totalAbonado.toFixed(2) + '\n'),
                textEncoder.encode('\x1B\x21\x11' + 'Restante: $' + restante.toFixed(2) + '\n'),
                textEncoder.encode('\x1B\x21\x00' + '-'.repeat(32) + '\n')
            );

            // Añadir Pie de ticket configurado
            const pieConfigurado = (parametrosCajaForm.pieticket || "");
            if (pieConfigurado.length > 0) {
                ticketParts.push(textEncoder.encode('\x1B\x61\x01' + pieConfigurado + '\n'));
                ticketParts.push(textEncoder.encode('\x1B\x61\x00' + '-'.repeat(32) + '\n'));
            }

            ticketParts.push(
                textEncoder.encode('\x1B\x61\x01' + 'Gracias por su apartado!\nVuelva pronto\n\n\n'),
                textEncoder.encode('\x1B\x64\x06'),
                textEncoder.encode('\x1D\x56\x00')
            );

            const totalLength = ticketParts.reduce((sum, part) => sum + part.length, 0);
            const finalTicket = new Uint8Array(totalLength);
            let offset = 0;
            ticketParts.forEach(part => {
                finalTicket.set(part, offset);
                offset += part.length;
            });

            formData.append("ticket", new Blob([finalTicket], { type: "application/octet-stream" }));
            formData.append("printerName", parametrosCajaForm.nombreimpresoraapartados?.trim() || "");

        const logoBase64 = parametrosCajaForm?.logo;
        if (logoBase64) {
            try {
                const binary = atob(logoBase64);
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
                formData.append("logo", new Blob([bytes], { type: "image/png" }), "logocliente.png");
            } catch (err) {
                handleOpenAlert("Logo no disponible: " + getErrorMessage(err), "error");
            }
        }

            const response2 = await fetch(`http://localhost:4000/api/imprimirticket`, {
                method: "POST",
                body: formData,
            });

            if (!response2.ok) {
                handleOpenAlert(`Error impresión estado de cuenta: ${response2.statusText}`);
                return;
            }

            handleOpenAlert("Estado de cuenta impreso correctamente", "OK");
        } catch (error) {
            handleOpenAlert(`Error al imprimir estado de cuenta: ${getErrorMessage(error)}`, "error");
        }
    };

    const handeCerrarModalDescuentos = () => {
        setStatusKeyActions(false);
        setStatusAbrirDescuentos(false);
    };

    const handleAplicarDescuentosManual = async () => {
        if (listaVenta.length === 0)
            return;

        setStatusWaiting(true);
        const response = await PostRequest({
            url: apiAplicarDescuentosVentas,
            body: listaVenta,
            loader: "Actualizando costos por descuento..."
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert("No se actualizaron los costos por descuento: " + response.message);
            return;
        }

        handleOpenAlert("Costos actualizados correctamente", "Alert");
        setStatusAbrirDescuentos(false);
        const data = await handleObtenerVentas("VENTA", parametrosCajaForm.folioventa, parametrosCajaForm.caja);
        await handleRetotalizarCuentaVenta(data ?? []);
        setStatusKeyActions(false);
    };

    const handleClickRefrescarDatosDescuentos = async () => {
        const data = await handleObtenerVentas("VENTA", parametrosCajaForm.folioventa, parametrosCajaForm.caja);
        await handleRetotalizarCuentaVenta(data ?? []);
        setStatusKeyActions(false);
    };

    const handleObtenerCortesAdministrativos = async () => {

    };

    const handleCargarDetallesCorte = async (caja, fecha) => {
        if (isNullOrEmpty(fecha) || isNullOrEmpty(caja))
            return;

        if (!statusHerramientasAdministrativas) return; //Si no hay un logeo administrativo cargado no muestra datos

        const fechaFormateada = format(new Date(fecha), 'yyyy-MM-dd');

        setStatusWaiting(true);
        const url = apiVentasDia.replace("{fechaventa}", fechaFormateada).replace("{pc}", caja.trim());
        const response = await GetRequest({
            url,
            loader: "Obteniendo datos de venta de la caja..."
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert("Error al obtener ventas por caja: " + response.Message);
            return;
        }

        setListaCortes(response?.result);
    };

    const handleOntenerListaCajasRegistro = async () => {
        setStatusWaiting(true);
        const response = await GetRequest({
            url: apiListaCajasRegistro,
            loader: "Obteniendo datos de venta de la caja..."
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert("Error al obtener la lista de cajas de registro: " + response.Message);
            return;
        }

        setListaCajas(response?.result);
    };

    const handleObtenerResumenTotalesCaja = async (fechaventa, pc, vendedor) => {
        if (!fechaventa || !pc) return null;

        const url = apiResumenTotalesCaja
            .replace("{fechaventa}", fechaventa)
            .replace("{pc}", pc)
            .replace("{vendedor}", vendedor || "N-A");

        setStatusWaiting(true);
        const response = await GetRequest({
            url: url,
        });
        setStatusWaiting(false);

        if (response.hasError) {
            handleOpenAlert(response.message);
            return null;
        }

        return response.result;
    };

    //#region manejocortescaja
    const [openModalCortes, setOpenModalCortes] = useState(false);
    const [openModalVisorCortes, setOpenModalVisorCortes] = useState(false);
    const [listaCortesCaja, setListaCortesCaja] = useState([]);
    const handleIniciarCorte = () => {
        setOpenModalCortes(true);
        setStatusKeyActions(true);
    };

    const handleAbrirVisorCortes = () => {
        setOpenModalVisorCortes(true);
        setStatusKeyActions(true);
    };

    const handleCerrarModalCortes = () => {
        setOpenModalCortes(false);
        setStatusKeyActions(false);
    };

    const handleCerrarModalVisorCortes = () => {
        setOpenModalVisorCortes(false);
        setStatusKeyActions(false);
    };

    const [openModalValidator, setOpenModalValidator] = useState(false);
    const handleOpenModalLoginValidatorCortes = () => {
        setOpenModalValidator(true);
    };

    const handleCloseModalLoginValidatorCortes = () => {
        setOpenModalValidator(false);
    };

    const handleAplicacionCortes = (status) => {
        if (!status) return;
        handleIniciarCorte();
    };

    const handleAplicarCorte = async (data) => {
        if (data.length === 0 || data == null) {
            handleOpenAlert("No hay datos para realizar corte")
            return;
        }
    };

    const [openModalValidarAcceso, setOpenModalValidarAcceso] = useState(false);
    const handleAbrirValidarAccesosHerramientas = () => {
        if (statusHerramientasAdministrativas) {
            setStatusHerramientasAdministrativas(false);
            setListaCortes([]);
            setListaVentas([]);
            return;
        }
        setOpenModalValidarAcceso(true);
        setStatusKeyActions(false);
    };

    const [statusHerramientasAdministrativas, setStatusHerramientasAdministrativas] = useState(false);
    const handleHabilitarHerramientas = (status) => {
        if (!status) return;
        setStatusHerramientasAdministrativas(true);
    };

    const handleCloseModalLoginValidarAcceso = () => {
        setOpenModalValidarAcceso(false);
        setStatusKeyActions(false);
    };

    const [openModalRetiroCapital, setOpenModalRetiroCapital] = useState(false);
    const [statusCajaRetiro, setStatusCajaRetiro] = useState(false);
    const [openModalLoginRetiro, setOpenModalLoginRetiro] = useState(false);
    const [usuarioAutorizadoRetiro, setUsuarioAutorizadoRetiro] = useState("");

    const handleAbrirRetiroCapital = async () => {
        const caja = parametrosCajaForm.caja;
        if (!caja || caja === 'CAJA-DEFAULT') {
            handleOpenAlert("No hay caja seleccionada", "warning");
            return;
        }
        setOpenModalLoginRetiro(true);
    };

    const handleConfirmLoginRetiro = async (success, usuarioAutorizado) => {
        setOpenModalLoginRetiro(false);
        setUsuarioAutorizadoRetiro(usuarioAutorizado || "");
        const caja = parametrosCajaForm.caja;
        try {
            const urlStatusCaja = apiStatusCaja.replace("{caja}", caja);
            const responseStatus = await GetRequest({ url: urlStatusCaja });
            if (responseStatus.hasError || !responseStatus.result) {
                handleOpenAlert("Error al obtener status de caja", "error");
                return;
            }
            if (!responseStatus.result.abierta) {
                handleOpenAlert("La caja está cerrada. Abra la caja primero.", "warning");
                return;
            }
            setStatusCajaRetiro(responseStatus.result);
            setOpenModalRetiroCapital(true);
        } catch (error) {
            handleOpenAlert("Error al abrir retiro de capital: " + getErrorMessage(error), "error");
        }
    };

    const handleCerrarRetiroCapital = () => {
        setOpenModalRetiroCapital(false);
        setStatusCajaRetiro(null);
        setUsuarioAutorizadoRetiro("");
    };
    const handleRetiroCapitalExitoso = async () => {
        setOpenModalRetiroCapital(false);
        setStatusCajaRetiro(null);
        setUsuarioAutorizadoRetiro("");
    };

    const handleGenerarCorteDetalles = (caja, fechaCorte, usuario, listaTiposMonedas) => {

    };

    //#endregion

    const handleClickDescuentoVenta = () => {
        setOpenModalValidarAcceso(true);
        setStatusKeyActions(true);
    }

    const handleAbrirDescuentosVenta = () => {
        setStatusAbrirDescuentos(true);
        setStatusKeyActions(true);
    }

    const handleAplicarDescuentosVenta = async (data) => {
        setListaVenta(data);
    }

    const handleObtenerVentasPorPeriodoAlmacen = async (parameters) => {
        if (isNullOrEmpty(parameters.fechaInicio) || isNullOrEmpty(parameters.fechaFin))
            return;

        setStatusWaiting(true);

        const fechaInicio = encodeURIComponent(parameters.fechaInicio);
        const fechaFin = encodeURIComponent(parameters.fechaFin);
        const almacen = encodeURIComponent((parameters.almacen || "").trim() || "TODOS");
        const filtro = encodeURIComponent((parameters.filtro || "").trim() || "TODOS");

        const url = apiVentasPeriodoAlmacen
            .replace("{fechainicio}", fechaInicio)
            .replace("{fechafin}", fechaFin)
            .replace("{almacenexhibidor}", almacen)
            .replace("{filtro}", filtro);

        const response = await GetRequest({
            url,
            loader: "Obteniendo ventas por periodo y almacen/exhibidor..."
        });

        setStatusWaiting(false);

        if (response.hasError) {
            setListaVenta([]);
            handleOpenAlert("Error al obtener ventas por periodo y almacen/exhibidor: " + response.message);
            return;
        }

        setListaVenta(response?.result ?? []);
        return response?.result ?? [];
    };


    return (
        <VentasContext.Provider
            value={{
                //#region main
                listaRemisionTemporal,
                clienteForm,
                partidaSeleccionada,
                openModalPartidas,
                idPartida, articuloActual,
                handleRefreshDataHost,
                handleChangePartidaSeleccionada,
                handlDobleClickEditarPartida,
                handleObtenerVentas,
                handleObtenerFolioCajaVentas, handleIncrementarFolioCajaVentas,
                handleCargarEscaneosFromFile,
                handleAbrirMenuModal, handleCerrarMenuModal, openModal,
                handleClickRegresarMainDashboard,
                handleRegistrarArticuloSubmitVenta,
                handleBuscarClienteFromName,
                handleBuscarClienteFromClave,
                handleViewFormDescuentos,
                statusValidarCliente, handleAbrirValidarCliente, handleCerrarValidarCliente,
                obtenerListaVentas,
                handleInicializarVentanaVentas,
                handleClickRefrescarDatosVenta,
                handleRetotalizarCuentaVenta,
                handleClickEliminarPartidaVentas, handleClickEliminarVenta, handleClickEliminarVentaFull,
                handleClickEditarPartida,
                handleCerrarModalEditarPartidas,
                handleSumarPartidaVentas,
                handleRestarPartidaVentas,
                handleSumarPartidaPreVentas,
                handleRestarPartidaPreVentas,
                openModalCobrarVenta, setOpenModalCobrarVenta,
                handClickCobrarVenta,
                handleGuardarVentaComoCotizacion,
                handleCerrarModalCobrarVenta, handleArirModalCobrarVenta,
                openModalBuscarCliente, setOpenModalBuscarCliente,
                handleCerrarModalBuscarCliente, handleArirModalBuscarCliente,
                handleConsultaMontoLetra,
                statusKeyActions,
                setVentaTotales, ventaTotales, getVentaTotalesForm,
                MontoEnLetra,
                handleAplicarDescuentoAClienteVenta,
                handleReimprimirTicket,
                dataRemision,
                openModalImpresion, setOpenModalImpresion,
                setClienteForm,
                handleObtenerListaImpresiorasLan, listaImpresoras,
                statusImpresionDirecta, setStatusImpresionDirecta,
                handleImprimirTicketEscapeCommand,
                openModalBuscarArticulos, setOpenModalBuscarArticulos,
                handleCloseModalBuscarArticulos, handleArirModalBuscarArticulos,
                handleCloseModalBuscarArticulosPreventas, handleArirModalBuscarArticulosPreventas,
                openModalBuscarArticulosPreventas, setOpenModalBuscarArticulosPreventas,
                statusCloseModal,
                listaPreventaTemporal,
                handleInicializarVentanaPreVentas,
                partidaSeleccionadaPreventas,
                handleChangePartidaSeleccionadaPreventas,
                handleClickEditarPartidaPreventas,
                handleClickRefrescarDatosPreVenta,
                handleClickEliminarPartidaPreVentas,
                handleRegistrarArticuloSubmitPreVenta,
                dataPreVenta,
                handleArirModalFirmarVenta,
                handleFirmarVenta,
                setParametrosCajaForm,
                handleClickEliminarPreVenta,
                handleCambioTipoVenta,
                handleArirModalFirmaPreVenta, handleCerrarModalFirmaPreVenta, openModalFirma,
                handleFirmarPreventa,
                handleCerrarModalJalarPreVentaCotizacion,
                handleAbrirModalJalarPreVentaCotizacion,
                openModalJalarPreventaCotizacion,
                handleInyectarPreventaCotizacionAVenta,
                //Preventas recuperación---------
                handleCerrarModalRecuperarPreVenta,
                handleRecuperarPreventas,
                openModalRecuperarPreventa,
                handleAbrirModalRecuperarPreVenta,
                handleCerrarModalRecuperarPreVentaFirma,
                openModalRecuperarPreventaFirma,
                //Modal preventa
                handleAbrirMenuModalPreventa,
                handleCerrarMenuModalPreventa,
                openModalPreventa,
                handleAbrirModalRecuperarPreVentaFirma,
                //Modal generar apartados
                handleAbrirModalGenerarApartado,
                handleCerrarModalGenerarApartado,
                openModalGenerarApartado,
                handleGenerarApartadoSubmit,
                handleGenerarApartadoConPagos,
                handClickCobrarAbonoApartado,
                handleAbrirModalGenerarAbonoApartados,
                handleAbrirModalEntregaDefinitiva,
                handleCerrarModalGenerarAbonoApartados,
                openModalCobrarAbonoApartado,
                isModoEntregaDefinitiva,
                statusCobroApartado,
                setStatusCobroApartado,
                statusActualApartado,
                setStatusActualApartado,
                openModalCambioCostoApartado,
                setOpenModalCambioCostoApartado,
                handleCambiarCostoArticuloApartado,
                handleAbrirModalCambioCostoApartados,
                handleCerrarModalCambioCostoApartados,
                dataApartados, setDataApartados,
                dataEstadoCuentaApartado, setDataEstadoCuentaApartado,
                rowPartidaApartadoFind, setRowPartidaApartadoFind,
                abonoApartadoSeleccionado, setAbonoApartadoSeleccionado,
                handleAbrirModalCancelarApartados,
                handleCerrarModalCancelarApartados,
                openModalCancelarApartado, setOpenModalCancelarApartado,
                handleCancelarApartadoSubmit,
                handleEntregaDefinitivaApartado,
                handleTerminarApartado,
                handleMantenimientoCuentasApartados,
                handleRefreshApartadosData,
                listaAlmacenesExhibidores,
                handleObtenerAlmacenesExhibidores,
                //Tickets
                dataTicket,
                setDataTicket,
                nombreTicket,
                setNombreTicket,
                handleImprimirTicket,
                handleImprimirTicketApartados,
                handleImprimirTicketAbono,
                handleReimprimirAbonoApartado,
                handleImprimirTicketAcuseEntrega,
                abonoDataGenerado,
                setAbonoDataGenerado,
                handleCerrarModalImpresion,
                handleClickEstadoCuentaCliente,
                statusWaiting, setStatusWaiting,
                statusAbrirDescuentos,
                setStatusAbrirDescuentos,
                handeCerrarModalDescuentos,
                listaVenta, setListaVenta, handleAplicarDescuentosManual,
                handleClickRefrescarDatosDescuentos,
                setStatusKeyActions,
                handleObtenerCortesAdministrativos,
                handleImprimirTicketCorte,
                listaCajas, setListaCajas, handleOntenerListaCajasRegistro,
                listaCortes, setListaCortes, handleCargarDetallesCorte,
                handleImprimirCorteCajaEscapeCommand,
                corteSeleccionado, setCorteSeleccionado,
                handleIniciarCorte,
                //#endregion

                //#region cortes
                //Cortes
                handleIniciarCorte,
                handleCerrarModalCortes,
                openModalCortes,
                openModalVisorCortes,
                setOpenModalCortes,
                setOpenModalVisorCortes,
                listaCortesCaja,
                setListaCortesCaja,
                openModalValidator,
                listaVentas,
                setListaVentas,
                handleGenerarCorteDetalles,

                //login validator
                handleCloseModalLoginValidatorCortes,
                handleOpenModalLoginValidatorCortes,
                handleAplicacionCortes,
                handleCerrarModalCortes,
                handleAplicarCorte,
                handleCerrarModalVisorCortes,
                openModalValidarAcceso,
                handleAbrirValidarAccesosHerramientas,
                statusHerramientasAdministrativas,
                handleHabilitarHerramientas,
                handleCloseModalLoginValidarAcceso,
                //#endregion 
                // Retiro Capital
                openModalRetiroCapital,
                openModalLoginRetiro,
                setOpenModalLoginRetiro,
                handleAbrirRetiroCapital,
                handleConfirmLoginRetiro,
                handleCerrarRetiroCapital,
                handleRetiroCapitalExitoso,
                statusCajaRetiro,
                usuarioAutorizadoRetiro,
                // Descuentos
                handleClickDescuentoVenta,
                handleAbrirDescuentosVenta,
                handleClickEliminarPreVentaDesdeVenta,
                handleClickLimpiarPreventas,

                handleAplicarDescuentosVenta,
                handleArirModalBuscarArticulos,
                handleObtenerVentaDelDiaCajaFecha,
                handleObtenerVentasPorPeriodoAlmacen,
                barcodeAnterior, setBarcodeAnterior,
                moduloActivo, setModuloActivo,
                handleObtenerResumenTotalesCaja,
                handleAbrirCajonDinero,
                handleImprimirReporteVentasAlmacen,
                fechaInicioVentas, setFechaInicioVentas,
                fechaFinVentas, setFechaFinVentas,
                almacenSeleccionadoVentas, setAlmacenSeleccionadVentas,
                filtroArticuloVentas, setFiltroArticuloVentas,
                listaVentasAgrupadas, setListaVentasAgrupadas,
                handleClickRegresarMainDashboard,
                mostrarBuscadorArticulos, setMostrarBuscadorArticulos,
            }}
        >
            {props.children}
        </VentasContext.Provider>
    );
};

export const useVentas = () => useContext(VentasContext);










